import React, {Component} from 'react'
import {connect} from 'react-redux'
import {
  validateSkillVendorSearchField,
  setSkillVendorSearchDropdownOptions,
  setSkillVendorSearchCheckboxValue,
  clearSkillVendorSearchFields
} from '../../../actions/pages/skillvendor-page'
import SingleLineSearchForm from '../../common/form/SingleLineSearchFormTalentSearch'
import InputField from '../../common/form/InputField'
import MultiSelect from '../../common/form/MultiSelectTalentSearch'
//import MultiSelectAutoComplete from '../../common/form/MultiSelectAutoCompleteTalentSearch'
import MultiSelectAutoComplete from '../../common/form/MultiSelectAutoCompleteCriteria'
import Select from '../../common/form/SelectTalentSearch'
import ReactSelectTalentSearch from '../../common/form/ReactSelectTalentSearch'
import {compose} from 'recompose'
import CheckboxField from "../../common/form/CheckboxFieldTalentSearch";
import WithAjax from '../../common/helpers/WithAjax'
import WithNotify from '../../common/helpers/WithNotify';
import { Collapse, CardBody, Card } from 'reactstrap';
import ReactSelect from 'react-select'
import {Modal, ModalHeader, ModalBody, ModalFooter} from 'reactstrap'
import {getCountryDBcode} from '../../../panel-admin/common/functions/countrySetting'

class SkillVendorSearch extends Component {
  constructor(props) {
    super(props);
    this.timeout = 0
    this.toggleAdaptor = this.toggleAdaptor.bind(this);
    this.toggleBooker = this.toggleBooker.bind(this);
    this.toggleDirector = this.toggleDirector.bind(this);
    this.toggleEditor = this.toggleEditor.bind(this);
    this.toggleLyricist = this.toggleLyricist.bind(this);
    this.toggleSinger = this.toggleSinger.bind(this);
    this.toggleSoundEngineer = this.toggleSoundEngineer.bind(this);
    this.toggleTranslator = this.toggleTranslator.bind(this);
    this.toggleVoiceActor = this.toggleVoiceActor.bind(this);
    this.toggleProductions = this.toggleProductions.bind(this);
    this.toggleBasicDetails = this.toggleBasicDetails.bind(this);
    this.getProductionId = this.getProductionId.bind(this)
    this.getVacancyId = this.getVacancyId.bind(this)
    this.getSkillTypeId = this.getSkillTypeId.bind(this)
    this.getCityId = this.getCityId.bind(this)
    this.getExternalExperienceId = this.getExternalExperienceId.bind(this)
    this.getSchoolId = this.getSchoolId.bind(this)
    this.getDoNotUseId = this.getDoNotUseId.bind(this)
    this.getAdaptorSchoolId = this.getAdaptorSchoolId.bind(this);
    this.getBookerSchoolId = this.getBookerSchoolId.bind(this);
    this.getDirectorSchoolId = this.getDirectorSchoolId.bind(this);
    this.getEditorSchoolId = this.getEditorSchoolId.bind(this);
    this.getLyricistSchoolId = this.getLyricistSchoolId.bind(this);
    this.getSingerSchoolId = this.getSingerSchoolId.bind(this);
    this.getSoundEngineerSchoolId = this.getSoundEngineerSchoolId.bind(this);
    this.getTranslatorSchoolId = this.getTranslatorSchoolId.bind(this);
    this.getVoiceActorSchoolId = this.getVoiceActorSchoolId.bind(this);
    this.getAdaptorStudioId = this.getAdaptorStudioId.bind(this);
    this.getAdaptorClientId = this.getAdaptorClientId.bind(this);
    this.getBookerStudioId = this.getBookerStudioId.bind(this);
    this.getBookerClientId = this.getBookerClientId.bind(this);
    this.getDirectorStudioId = this.getDirectorStudioId.bind(this);
    this.getDirectorClientId = this.getDirectorClientId.bind(this);
    this.getEditorStudioId = this.getEditorStudioId.bind(this);
    this.getEditorClientId = this.getEditorClientId.bind(this);
    this.getLyricistStudioId = this.getLyricistStudioId.bind(this);
    this.getLyricistClientId = this.getLyricistClientId.bind(this);
    this.getSingerStudioId = this.getSingerStudioId.bind(this);
    this.getSingerClientId = this.getSingerClientId.bind(this);
    this.getSoundEngineerStudioId = this.getSoundEngineerStudioId.bind(this);
    this.getSoundEngineerClientId = this.getSoundEngineerClientId.bind(this);
    this.getTranslatorStudioId = this.getTranslatorStudioId.bind(this);
    this.getTranslatorClientId = this.getTranslatorClientId.bind(this);
    this.getVoiceActorStudioId = this.getVoiceActorStudioId.bind(this);
    this.getVoiceActorClientId = this.getVoiceActorClientId.bind(this);
    this.onClearFields = this.onClearFields.bind(this);
    this.handleFilterList = this.handleFilterList.bind(this)
    this.setFilters = this.setFilters.bind(this);


    this.loadFilterList = this.loadFilterList.bind(this)
    this.saveAsFilterList = this.saveAsFilterList.bind(this)
    this.removeFilterList = this.removeFilterList.bind(this)
    this.updateFilterList = this.updateFilterList.bind(this)
    this.cleanSearchForm = this.cleanSearchForm.bind(this)


    this.state = {
      collapseAdaptor: false,
      collapseBooker: false,
      collapseDirector: false,
      collapseEditor: false,
      collapseLyricist: false,
      collapseSinger: false,
      collapseSoundEngineer: false,
      collapseTranslator: false,
      collapseVoiceActor: false,
      collapseProductions: false,
      collapseBasicDetails: false,
      productionId:[],
      vacancyId:[],
      skillTypeId:'',
      externalExperienceId:'',
      schoolId:'',
      doNotUse:'',
      adaptorSchoolId: '',
      bookerSchoolId: '',
      directorSchoolId: '',
      editorSchoolId: '',
      lyricistSchoolId: '',
      singerSchoolId: '',
      soundEngineerSchoolId: '',
      translatorSchoolId: '',
      voiceActorSchoolId: '',
      adaptorStudioId: '',
      adaptorClientId: [],
      bookerStudioId: '',
      bookerClientId: '',
      directorStudioId: '',
      directorClientId: '',
      editorStudioId: '',
      editorClientId: '',
      lyricistStudioId: '',
      lyricistClientId: '',
      singerStudioId: '',
      singerClientId: '',
      soundEngineerStudioId: '',
      soundEngineerClientId: '',
      translatorStudioId: '',
      translatorClientId: '',
      voiceActorStudioId: '',
      voiceActorClientId: '',
      isEthnicity: false,
      isIdentity: false,
      isAccent: false,
      clear: false,
      isRegion: false,
      nativeLanguageSelectedValue:'',
      additionalLanguagesSelectedValue:'',
      countrySelectedValue:'',
      citySelectedValue:'',
      regionSelectedValue:'',
      ethnicitySelectedValue:'',
      ethnicityExists:false,
      identitySelectedValue: '',
      identityExists:false,
      skillLevelSelectedValue: '',
      skillTypeSelectedValue: '',
      ageFromSelectedValue:'',
      ageToSelectedValue:'',
      doNotUseSelectedValue:'',
      knownTalentSelectedValue:'',
      skillVendorStatusSelectedValue:'',
      voiceAgeSelectedValue:'',
      voiceTypeSelectedValue:'',
      liveActionVoiceGenderMale:'',
      liveActionVoiceGenderFemale:'',
      voiceActorAnimationMaleVoiceGender:'',
      voiceActorTheatricalExperience:'',
      voiceActorTVExperience:'',
      voiceActorVideoGamesExperience:'',
      voiceActorPromoOrCommercialsExperience:'',
      voiceActorLiveActionExperience:'',
      voiceActorAnimationExperience:'',
      voiceActorDubbingExperience:'',
      voiceActorAudiobooksExperience:'',
      voiceActorVoiceOverExperience:'',
      voiceActorRadioExperience:'',
      voiceActorTheatreActorExperience:'',
      voiceActorMovieActorExperience:'',
      voiceActorAudioDescriptionExperience:'',
      voiceActorStudio:'',
      voiceActorClient:'',
      voiceActorUnionSelectedValue:'',
      isVoiceActorUnion:false,
      voiceActorSchool:'',
      voiceActorGenderNeutralVoice:'',
      languageAccent:'',
      productionCast:'',
      externalExperienceCast:'',
      vacancyCast:'',
      remoteRecordingListVoiceActorSelectedValue:'',
      bookerTheatricalExperience:'',
      bookerTVExperience:'',
      bookerInteractiveExperience:'',
      bookerStudio:'',
      directorTheatricalExperience:'',
      directorTVExperience:'',
      directorVideoGamesExperience:'',
      directorPromoCommercialsExperience:'',
      directorLiveActionExperience:'',
      directorAnimationExperience:'',
      directorDubbingDirectorExperience:'',
      directorVoiceOverDirectorExperience:'',
      directorSongDirectorExperience:'',
      directorDubbingActorExperience:'',
      directorStageDirectorExperience:'',
      directorMovieDirectorExperience:'',
      directorAudioDescriptionExperience:'',
      directorStudio:'',
      directorClient:'',
      directorSchool:'',
      remoteRecordingDirectorSelectedValue:'',
      directorAppAccess:'',
      lyricistMusicalExperience:'',
      lyricistTheatreExperience:'',
      lyricistPromoCommercialsExperience:'',
      lyricistExperience:'',
      lyricistDubbingExperience:'',
      lyricistMusicianExperience:'',
      lyricistNumberOfSongsWritten:'',
      lyricistUniversityDegree:'',
      lyricistStudio:'',
      lyricistClient:'',
      remoteRecordingLyricistSelectedValue:'',
      singerMaleVoiceGender:'',
      singerFemaleVoiceGender:'',
      voiceAgeSingerSelectedValue: '',
      vocalRangeSingerSelectedValue: '',
      readingMusicNoteSingerSelectedValue: '',
      singerDubbingExperience:'',
      singerStageExperience:'',
      singerTheatreExperience:'',
      singerTalentShowExperience:'',
      singerStudio:'',
      singerClient:'',
      singerSchool:'',
      remoteRecordingSingerSelectedValue:'',
      singerUnionSelectedValue:'',
      isSingerUnion:false,
      singerGenderNeutralVoice:'',
      translatorTheatricalExperience:'',
      translatorTVExperience:'',
      translatorGamesExperience:'',
      translatorPromoOrCommercialsExperience:'',
      translatorLiveActionExperience:'',
      translatorAnimationExperience:'',
      translatorSubtitlesExperience:'',
      translatorDubbingExperience:'',
      translatorVoiceOverExperience:'',
      translatorGamingExperience:'',
      translatorAudioDescriptionExperience:'',
      translatorHOHSDHCCExperience:'',
      translatorNumberOfTranslations:'',
      translatorUniversityDegree:'',
      translatorStudios:'',
      translatorClients:'',
      editorDubbingExperience:'',
      editorVoiceOverExperience:'',
      editorSongsExperience:'',
      editorProToolsExperience:'',
      editorDolby51Experience:'',
      editorAtmosExperience:'',
      editorFoleyExperience:'',
      editorRecordingEditingExperience:'',
      editorDialogueEditingExperience:'',
      editorMusicAndEffectsExperience:'',
      editorMixEditingExperience:'',
      editorPreparingTakesExperience:'',
      editorAudioDescriptionExperience:'',
      editorStudios:'',
      editorClients:'',
      editorSchools:'',
      editorRemoteRecordingCapability:'',
      adaptorTheatricalExperience:'',
      adaptorTVExperience:'',
      adaptorGamesExperience:'',
      adaptorPromoOrCommercialsExperience:'',
      adaptorLiveActionExperience:'',
      adaptorAnimationExperience:'',
      adaptorAdaptorExperience:'',
      adaptorDubbingDirectorExperience:'',
      adaptorTranslatorExperience:'',
      adaptorVoiceActorExperience:'',
      adaptorAudioDescriptionExperience:'',
      adaptorNumberOfAdaptionsRange:'',
      adaptorUniversityDegree:'',
      adaptorStudios:'',
      adaptorClients:'',
      soundEngineerDubbingExperience:'',
      soundEngineerVoiceOverExperience:'',
      soundEngineerSongsExperience:'',
      soundEngineerProToolsExperience:'',
      soundEngineerDolby51Experience:'',
      soundEngineerAtmosExperience:'',
      soundEngineerFoleyExperience:'',
      soundEngineerDialogueRecordingExperience:'',
      soundEngineerSongRecordingExperience:'',
      soundEngineerDialogueMixingExperience:'',
      soundEngineerSongMixingExperience:'',
      soundEngineerAudioDescriptionMixingExperience:'',
      soundEngineerStudios:'',
      soundEngineerClients:'',
      soundEngineerSchools:'',
      soundEngineerRemoteRecordingCapability:'',
      selectedSaveFilterOption: '',
      checkedFilters:null,
      filterList:null,
      filterModal:false,
      filterListName:'',
      itemsForFilter:[],
      fullTextSearchForFilter: '',
      filterListModal:false,
      selectedFilterListName:'',
      selectedFilterList:'',
      selectedFilterListId:'',
      filterListNameError:null,
      adaptorDoNotUse:'',
      bookerDoNotUse:'',
      directorDoNotUse:'',
      editorDoNotUse:'',
      lyricistDoNotUse:'',
      singerDoNotUse:'',
      soundEngineerDoNotUse:'',
      translatorDoNotUse:'',
      voiceActorDoNotUse:'',
      skillVendorStatusCheckboxSelectedValue: '',
      filterListColor: false
    };
  }

  toggleAdaptor() {
    this.setState({ collapseAdaptor: !this.state.collapseAdaptor });
  }
  toggleBooker() {
    this.setState({ collapseBooker: !this.state.collapseBooker });
  }
  toggleDirector() {
    this.setState({ collapseDirector: !this.state.collapseDirector });
  }
  toggleEditor() {
    this.setState({ collapseEditor: !this.state.collapseEditor });
  }
  toggleLyricist() {
    this.setState({ collapseLyricist: !this.state.collapseLyricist });
  }
  toggleSinger() {
    this.setState({ collapseSinger: !this.state.collapseSinger });
  }
  toggleSoundEngineer() {
    this.setState({ collapseSoundEngineer: !this.state.collapseSoundEngineer });
  }
  toggleTranslator() {
    this.setState({ collapseTranslator: !this.state.collapseTranslator });
  }
  toggleVoiceActor() {
    this.setState({ collapseVoiceActor: !this.state.collapseVoiceActor });
  }
  toggleProductions() {
    this.setState({ collapseProductions: !this.state.collapseProductions });
  }
  toggleBasicDetails() {
    this.setState({ collapseBasicDetails: !this.state.collapseBasicDetails });
  }


  getProductionId(id){
    this.setState({
      productionId:id,
      clear: false
    })
  }

  getVacancyId(id){
    this.setState({
      vacancyId:id,
      clear: false
    })
  }

  getSkillTypeId(id){
    this.setState({skillTypeId:id})
  }

  getCityId(id){
    this.setState({cityId:id})
  }

  getExternalExperienceId(id){
    this.setState({
      externalExperienceId:id,
      clear: false
    })
  }

  getSchoolId(id){
    this.setState({schoolId:id})
  }

  getDoNotUseId(id){
    this.setState({getDoNotUseId:id})
  }


  getAdaptorSchoolId(id){
    this.setState({adaptorSchoolId:id})
  }

  getBookerSchoolId(id){
    this.setState({bookerSchoolId:id})
  }

  getDirectorSchoolId(id){
    this.setState({directorSchoolId:id})
  }

  getEditorSchoolId(id){
    this.setState({editorSchoolId:id})
  }

  getLyricistSchoolId(id){
    this.setState({lyricistSchoolId:id})
  }

  getSingerSchoolId(id){
    this.setState({singerSchoolId:id})
  }

  getSoundEngineerSchoolId(id){
    this.setState({soundEngineerSchoolId:id})
  }

  getTranslatorSchoolId(id){
    this.setState({translatorSchoolId:id})
  }

  getVoiceActorSchoolId(id){
    this.setState({voiceActorSchoolId:id})
  }


  getAdaptorStudioId(id){
    this.setState({adaptorStudioId:id})
  }

  getAdaptorClientId(id){
    this.setState({
      adaptorClientId:id,
      clear: false
    })
  }

  getBookerStudioId(id){
    this.setState({bookerStudioId:id})
  }

  getBookerClientId(id){
    this.setState({bookerClientId:id})
  }

  getDirectorClientId(id){
    this.setState({directorClientId:id})
  }

  getDirectorStudioId(id){
    this.setState({directorStudioId:id})
  }

  getEditorClientId(id){
    this.setState({editorClientId:id})
  }

  getEditorStudioId(id){
    this.setState({editorStudioId:id})
  }

  getLyricistClientId(id){
    this.setState({lyricistClientId:id})
  }

  getLyricistStudioId(id){
    this.setState({lyricistStudioId:id})
  }

  getSingerClientId(id){
    this.setState({singerClientId:id})
  }

  getSingerStudioId(id){
    this.setState({singerStudioId:id})
  }

  getSoundEngineerClientId(id){
    this.setState({soundEngineerClientId:id})
  }

  getSoundEngineerStudioId(id){
    this.setState({soundEngineerStudioId:id})
  }

  getTranslatorClientId(id){
    this.setState({translatorClientId:id})
  }

  getTranslatorStudioId(id){
    this.setState({translatorStudioId:id})
  }

  getVoiceActorClientId(id){
    this.setState({voiceActorClientId:id})
  }

  getVoiceActorStudioId(id){
    this.setState({voiceActorStudioId:id})
  }

  componentWillUnmount(){
    this.props.clearSkillVendorSearchFields();
  }

  onClearFields(){
    this.setState({
      collapseAdaptor: false,
      collapseBooker: false,
      collapseDirector: false,
      collapseEditor: false,
      collapseLyricist: false,
      collapseSinger: false,
      collapseSoundEngineer: false,
      collapseTranslator: false,
      collapseVoiceActor: false,
      collapseProductions: false,
      collapseBasicDetails: false,
      productionId:[],
      vacancyId:[],
      skillTypeId:'',
      externalExperienceId:'',
      schoolId:'',
      doNotUse:'',
      adaptorSchoolId: '',
      bookerSchoolId: '',
      directorSchoolId: '',
      editorSchoolId: '',
      lyricistSchoolId: '',
      singerSchoolId: '',
      soundEngineerSchoolId: '',
      translatorSchoolId: '',
      voiceActorSchoolId: '',
      adaptorStudioId: '',
      adaptorClientId: [],
      bookerStudioId: '',
      bookerClientId: '',
      directorStudioId: '',
      directorClientId: '',
      editorStudioId: '',
      editorClientId: '',
      lyricistStudioId: '',
      lyricistClientId: '',
      singerStudioId: '',
      singerClientId: '',
      soundEngineerStudioId: '',
      soundEngineerClientId: '',
      translatorStudioId: '',
      translatorClientId: '',
      voiceActorStudioId: '',
      voiceActorClientId: '',
      isEthnicity: false,
      isIdentity: false,
      isAccent: false,
      clear: false,
      isRegion: false,
      nativeLanguageSelectedValue:'',
      additionalLanguagesSelectedValue:'',
      countrySelectedValue:'',
      citySelectedValue:'',
      regionSelectedValue:'',
      ethnicitySelectedValue:'',
      ethnicityExists:false,
      identitySelectedValue: '',
      identityExists:false,
      skillLevelSelectedValue: '',
      skillTypeSelectedValue: '',
      ageFromSelectedValue:'',
      ageToSelectedValue:'',
      doNotUseSelectedValue:'',
      knownTalentSelectedValue:'',
      skillVendorStatusSelectedValue:'',
      voiceAgeSelectedValue:'',
      voiceTypeSelectedValue:'',
      liveActionVoiceGenderMale:'',
      liveActionVoiceGenderFemale:'',
      voiceActorAnimationMaleVoiceGender:'',
      voiceActorAnimationFemaleVoiceGender:'',
      voiceActorTheatricalExperience:'',
      voiceActorTVExperience:'',
      voiceActorVideoGamesExperience:'',
      voiceActorPromoOrCommercialsExperience:'',
      voiceActorLiveActionExperience:'',
      voiceActorAnimationExperience:'',
      voiceActorDubbingExperience:'',
      voiceActorAudiobooksExperience:'',
      voiceActorVoiceOverExperience:'',
      voiceActorRadioExperience:'',
      voiceActorTheatreActorExperience:'',
      voiceActorMovieActorExperience:'',
      voiceActorAudioDescriptionExperience:'',
      voiceActorStudio:'',
      voiceActorClient:'',
      voiceActorUnionSelectedValue:'',
      isVoiceActorUnion:false,
      voiceActorSchool:'',
      voiceActorGenderNeutralVoice:'',
      languageAccent:'',
      productionCast:'',
      externalExperienceCast:'',
      vacancyCast:'',
      remoteRecordingListVoiceActorSelectedValue:'',
      bookerTheatricalExperience:'',
      bookerTVExperience:'',
      bookerInteractiveExperience:'',
      bookerStudio:'',
      directorTheatricalExperience:'',
      directorTVExperience:'',
      directorVideoGamesExperience:'',
      directorPromoCommercialsExperience:'',
      directorLiveActionExperience:'',
      directorAnimationExperience:'',
      directorDubbingDirectorExperience:'',
      directorVoiceOverDirectorExperience:'',
      directorSongDirectorExperience:'',
      directorDubbingActorExperience:'',
      directorStageDirectorExperience:'',
      directorMovieDirectorExperience:'',
      directorAudioDescriptionExperience:'',
      directorGamesExperience:'',
      directorPromoOrCommercialsExperience:'',
      directorStudio:'',
      directorClient:'',
      directorSchool:'',
      remoteRecordingDirectorSelectedValue:'',
      directorAppAccess:'',
      lyricistMusicalExperience:'',
      lyricistTheatreExperience:'',
      lyricistPromoCommercialsExperience:'',
      lyricistExperience:'',
      lyricistDubbingExperience:'',
      lyricistMusicianExperience:'',
      lyricistNumberOfSongsWritten:'',
      lyricistUniversityDegree:'',
      lyricistStudio:'',
      lyricistClient:'',
      remoteRecordingLyricistSelectedValue:'',
      singerMaleVoiceGender:'',
      singerFemaleVoiceGender:'',
      voiceAgeSingerSelectedValue: '',
      vocalRangeSingerSelectedValue: '',
      readingMusicNoteSingerSelectedValue: '',
      singerDubbingExperience:'',
      singerStageExperience:'',
      singerTheatreExperience:'',
      singerTalentShowExperience:'',
      singerStudio:'',
      singerClient:'',
      singerSchool:'',
      remoteRecordingSingerSelectedValue:'',
      singerUnionSelectedValue:'',
      isSingerUnion:false,
      singerGenderNeutralVoice:'',
      translatorTheatricalExperience:'',
      translatorTVExperience:'',
      translatorGamesExperience:'',
      translatorPromoOrCommercialsExperience:'',
      translatorLiveActionExperience:'',
      translatorAnimationExperience:'',
      translatorSubtitlesExperience:'',
      translatorDubbingExperience:'',
      translatorVoiceOverExperience:'',
      translatorGamingExperience:'',
      translatorAudioDescriptionExperience:'',
      translatorHOHSDHCCExperience:'',
      translatorNumberOfTranslations:'',
      translatorUniversityDegree:'',
      translatorStudios:'',
      translatorClients:'',
      editorDubbingExperience:'',
      editorVoiceOverExperience:'',
      editorSongsExperience:'',
      editorProToolsExperience:'',
      editorDolby51Experience:'',
      editorAtmosExperience:'',
      editorFoleyExperience:'',
      editorRecordingEditingExperience:'',
      editorDialogueEditingExperience:'',
      editorMusicAndEffectsExperience:'',
      editorMixEditingExperience:'',
      editorPreparingTakesExperience:'',
      editorAudioDescriptionExperience:'',
      editorStudios:'',
      editorClients:'',
      editorSchools:'',
      editorRemoteRecordingCapability:'',
      adaptorTheatricalExperience:'',
      adaptorTVExperience:'',
      adaptorGamesExperience:'',
      adaptorPromoOrCommercialsExperience:'',
      adaptorLiveActionExperience:'',
      adaptorAnimationExperience:'',
      adaptorAdaptorExperience:'',
      adaptorDubbingDirectorExperience:'',
      adaptorTranslatorExperience:'',
      adaptorVoiceActorExperience:'',
      adaptorAudioDescriptionExperience:'',
      adaptorNumberOfAdaptionsRange:'',
      adaptorUniversityDegree:'',
      adaptorStudios:'',
      adaptorClients:'',
      soundEngineerDubbingExperience:'',
      soundEngineerVoiceOverExperience:'',
      soundEngineerSongsExperience:'',
      soundEngineerProToolsExperience:'',
      soundEngineerDolby51Experience:'',
      soundEngineerAtmosExperience:'',
      soundEngineerFoleyExperience:'',
      soundEngineerDialogueRecordingExperience:'',
      soundEngineerSongRecordingExperience:'',
      soundEngineerDialogueMixingExperience:'',
      soundEngineerSongMixingExperience:'',
      soundEngineerAudioDescriptionMixingExperience:'',
      soundEngineerStudios:'',
      soundEngineerClients:'',
      soundEngineerSchools:'',
      soundEngineerRemoteRecordingCapability:'',
      selectedSaveFilterOption: '',
      checkedFilters:null,
      filterList:null,
      filterModal:false,
      filterListName:'',
      itemsForFilter:[],
      fullTextSearchForFilter: '',
      filterListModal:false,
      selectedFilterListName:'',
      selectedFilterList:'',
      //selectedFilterListId:'',
      filterListNameError:null,
      adaptorDoNotUse:'',
      bookerDoNotUse:'',
      directorDoNotUse:'',
      editorDoNotUse:'',
      lyricistDoNotUse:'',
      singerDoNotUse:'',
      soundEngineerDoNotUse:'',
      tanslatorDoNotUse:'',
      translatorDoNotUse:'',
      voiceActorDoNotUse:'',
      skillVendorStatusCheckboxSelectedValue: '',
      filterListColor: false
    });

 }

  getListsFromSkillVendorSearch(){
   let url = 'skillVendors/searchpage';
   this.props.ajax.get(url, true, (data) => {

     var ageFromList = {Items: [], SelectedValue: this.state.ageFromSelectedValue};
     for (var i = 1; i < 101; i++){
       ageFromList.Items.push({ value: i.toString(), label: i.toString() });
     }

     //age to list
     var ageToList = {Items: [], SelectedValue: this.state.ageToSelectedValue};
     for (var i = 1; i < 101; i++){
       ageToList.Items.push({ value: i, label: i.toString() });
     }


     //nativeLanguage new object
     var nativeLanguageList = {Items: [], SelectedValue: this.state.nativeLanguageSelectedValue};
     var nativeLanguageObj = data.NativeLanguages.Items;
     for (var i = 0; i < nativeLanguageObj.length; i++){
       nativeLanguageList.Items.push({ value:nativeLanguageObj[i].id , label:nativeLanguageObj[i].label  });
     }


     //experience new object
     var experienceList = {Items: [], SelectedValue: this.state.additionalLanguagesSelectedValue};
     var experienceObj = data.Experiences.Items;
     for (var i = 0; i < experienceObj.length; i++){
       experienceList.Items.push({ value:experienceObj[i].id , label:experienceObj[i].label  });
     }

     //remoteRecording new object
     var remoteRecordingList = {Items: [], SelectedValue: ''};
     var remoteRecordingObj = data.RemoteRecordingCapabilities.Items;
     for (var i = 0; i < remoteRecordingObj.length; i++){
       remoteRecordingList.Items.push({ value:remoteRecordingObj[i].id , label:remoteRecordingObj[i].label  });
     }

     var remoteRecordingDirector = {Items: [], SelectedValue: this.state.remoteRecordingDirectorSelectedValue};
     var remoteRecordingObj = data.RemoteRecordingCapabilities.Items;
     for (var i = 0; i < remoteRecordingObj.length; i++){
       remoteRecordingDirector.Items.push({ value:remoteRecordingObj[i].id , label:remoteRecordingObj[i].label  });
     }

     //lyricist remoteRecording new object
     var remoteRecordingListLyricist = {Items: [], SelectedValue: this.state.remoteRecordingLyricistSelectedValue};
     var remoteRecordingObj = data.RemoteRecordingCapabilities.Items;
     for (var i = 0; i < remoteRecordingObj.length; i++){
       remoteRecordingListLyricist.Items.push({ value:remoteRecordingObj[i].id , label:remoteRecordingObj[i].label  });
     }

     //remoteRecording new object
     var remoteRecordingListVoiceActor = {Items: [], SelectedValue: this.state.remoteRecordingListVoiceActorSelectedValue};
     var remoteRecordingObj = data.RemoteRecordingCapabilities.Items;
     for (var i = 0; i < remoteRecordingObj.length; i++){
       remoteRecordingListVoiceActor.Items.push({ value:remoteRecordingObj[i].id , label:remoteRecordingObj[i].label  });
     }

     //singer remoteRecording new object
     var remoteRecordingListSinger = {Items: [], SelectedValue: this.state.remoteRecordingSingerSelectedValue};
     var remoteRecordingObj = data.RemoteRecordingCapabilities.Items;
     for (var i = 0; i < remoteRecordingObj.length; i++){
       remoteRecordingListSinger.Items.push({ value:remoteRecordingObj[i].id , label:remoteRecordingObj[i].label  });
     }

     //remoteRecording new object
     var remoteRecordingEditor = {Items: [], SelectedValue: this.state.editorRemoteRecordingCapability};
     var remoteRecordingObj = data.RemoteRecordingCapabilities.Items;
     for (var i = 0; i < remoteRecordingObj.length; i++){
       remoteRecordingEditor.Items.push({ value:remoteRecordingObj[i].id , label:remoteRecordingObj[i].label  });
     }

     //remoteRecording new object
     var remoteRecordingListSoundEngineer = {Items: [], SelectedValue: this.state.soundEngineerRemoteRecordingCapability};
     var remoteRecordingObj = data.RemoteRecordingCapabilities.Items;
     for (var i = 0; i < remoteRecordingObj.length; i++){
       remoteRecordingListSoundEngineer.Items.push({ value:remoteRecordingObj[i].id , label:remoteRecordingObj[i].label  });
     }

     //numberOfAdaptionsRange new object
     var numberOfAdaptionsRangeList = {Items: [], SelectedValue: this.state.adaptorNumberOfAdaptionsRange};
     var numberOfAdaptionsRangeObj = data.NumberOfAdaptionsRanges.Items;
     for (var i = 0; i < numberOfAdaptionsRangeObj.length; i++){
       numberOfAdaptionsRangeList.Items.push({ value:numberOfAdaptionsRangeObj[i].id , label:numberOfAdaptionsRangeObj[i].label  });
     }

     //numberOfSongsWrittenRange new object
     var numberOfSongsWrittenRangeList = {Items: [], SelectedValue: this.state.lyricistNumberOfSongsWritten};
     var numberOfSongsWrittenRangeObj = data.NumberOfSongsWrittenRanges.Items;
     for (var i = 0; i < numberOfSongsWrittenRangeObj.length; i++){
       numberOfSongsWrittenRangeList.Items.push({ value:numberOfSongsWrittenRangeObj[i].id , label:numberOfSongsWrittenRangeObj[i].label  });
     }

     //numberOfTranslationsRange new object
     var numberOfTranslationsRangeList = {Items: [], SelectedValue: this.state.translatorNumberOfTranslations};
     var numberOfTranslationsRangeObj = data.NumberOfTranslationsRanges.Items;
     for (var i = 0; i < numberOfTranslationsRangeObj.length; i++){
       numberOfTranslationsRangeList.Items.push({ value:numberOfTranslationsRangeObj[i].id , label:numberOfTranslationsRangeObj[i].label  });
     }

     //skillLevel new object
     var skillLevelList = {Items: [], SelectedValue: this.state.skillLevelSelectedValue};
     var skillLevelObj = data.SkillLevels.Items;
     for (var i = 0; i < skillLevelObj.length; i++){
       skillLevelList.Items.push({ value:skillLevelObj[i].id , label:skillLevelObj[i].label  });
     }

     //gender new object
     var genderList = {Items: [], SelectedValue: ''};
     var genderObj = data.Genders.Items;
     for (var i = 0; i < genderObj.length; i++){
       genderList.Items.push({ value:genderObj[i].id , label:genderObj[i].label  });
     }

     //city new object
     // var cityList = {Items: [], SelectedValue: this.state.citySelectedValue}
     var cityList = {Items: [], SelectedValue: this.state.citySelectedValue};
     var cityObj = data.Cities.Items;
     for (var i = 0; i < cityObj.length; i++){
       cityList.Items.push({ value:cityObj[i].id , label:cityObj[i].label  });
     }


     //skillType new object
     var skillTypeList = {Items: [], SelectedValue: this.state.skillTypeSelectedValue};
     var skillTypeObj = data.SkillTypes.Items;
     for (var i = 0; i < skillTypeObj.length; i++){
       if(skillTypeObj[i].id == 0){
         var idsArr = [];
         for (var j = 0; j < skillTypeObj[i].Children.length; j++){
           idsArr.push(skillTypeObj[i].Children[j].id)
         }
         skillTypeList.Items.push({ value:idsArr , label:skillTypeObj[i].label  });
       }else{
           skillTypeList.Items.push({ value:skillTypeObj[i].id , label:skillTypeObj[i].label});
       }
     }


     //school new object
     var schoolList = {Items: [], SelectedValue: this.state.voiceActorSchool};

     var schoolObj = data.Schools.Items;
     for (var i = 0; i < schoolObj.length; i++){
       schoolList.Items.push({ value:schoolObj[i].id , label:schoolObj[i].label  });
     }

     //skillVendorStatus new object
     var statusList = {Items: [], SelectedValue: ''};
     var statusObj = data.SkillVendorStatuses.Items;
     for (var i = 0; i < statusObj.length; i++){
       statusList.Items.push({ value:statusObj[i].id , label:statusObj[i].label  });
     }

     //UniversityDegree new object translator
     var universityDegreeList = {Items: [], SelectedValue: this.state.translatorUniversityDegree};
     var universityDegreeObj = data.UniversityDegrees.Items;
     for (var i = 0; i < universityDegreeObj.length; i++){
       universityDegreeList.Items.push({ value:universityDegreeObj[i].id , label:universityDegreeObj[i].label  });
     }

     //adaptor UniversityDegree new object
     var universityDegreeListAdaptor = {Items: [], SelectedValue: this.state.adaptorUniversityDegree};
     var universityDegreeObj = data.UniversityDegrees.Items;
     for (var i = 0; i < universityDegreeObj.length; i++){
       universityDegreeListAdaptor.Items.push({ value:universityDegreeObj[i].id , label:universityDegreeObj[i].label  });
     }

     //lyricist UniversityDegree new object
     var universityDegreeListLyricist = {Items: [], SelectedValue: this.state.lyricistUniversityDegree};
     var universityDegreeObj = data.UniversityDegrees.Items;
     for (var i = 0; i < universityDegreeObj.length; i++){
       universityDegreeListLyricist.Items.push({ value:universityDegreeObj[i].id , label:universityDegreeObj[i].label  });
     }

     //VocalRange new object singer
     var vocalRangeList = {Items: [], SelectedValue: this.state.vocalRangeSingerSelectedValue};
     var vocalRangeObj = data.VocalRanges.Items;
     for (var i = 0; i < vocalRangeObj.length; i++){
       vocalRangeList.Items.push({ value:vocalRangeObj[i].id , label:vocalRangeObj[i].label  });
     }

     //MusicNotesReadingLevel new object singer
     var musicNotesReadingLevelList = {Items: [], SelectedValue: this.state.readingMusicNoteSingerSelectedValue};
     var musicNotesReadingLevelObj = data.MusicNotesReadingLevels.Items;
     for (var i = 0; i < musicNotesReadingLevelObj.length; i++){
       musicNotesReadingLevelList.Items.push({ value:musicNotesReadingLevelObj[i].id , label:musicNotesReadingLevelObj[i].label  });
     }

     //VoiceAgeRange new object
     var voiceAgeRangeList = {Items: [], SelectedValue: this.state.voiceAgeSelectedValue};
     var oiceAgeRangeObj = data.VoiceAgeRanges.Items;
     for (var i = 0; i < oiceAgeRangeObj.length; i++){
       voiceAgeRangeList.Items.push({ value:oiceAgeRangeObj[i].id , label:oiceAgeRangeObj[i].label  });
     }

     // singer VoiceAgeRange new object
     var voiceAgeRangeListSinger = {Items: [], SelectedValue: this.state.voiceAgeSingerSelectedValue};
     var voiceAgeRangeObj = data.VoiceAgeRanges.Items;
     for (var i = 0; i < voiceAgeRangeObj.length; i++){
       voiceAgeRangeListSinger.Items.push({ value:voiceAgeRangeObj[i].id , label:voiceAgeRangeObj[i].label  });
     }

     //country new object
     var countryList = {Items: [], SelectedValue: this.state.countrySelectedValue};
     var countryObj = data.CountriesOfLiving.Items;
     for (var i = 0; i < countryObj.length; i++){
       countryList.Items.push({ value:countryObj[i].id , label:countryObj[i].label  });
     }

     //ethnicity new object
     var ethnicityList = {Items: [], SelectedValue: this.state.ethnicitySelectedValue};
     if(data.Ethnicities.Items.length>0){
       this.setState({isEthnicity: true});
       var ethnicityObj = data.Ethnicities.Items;
       for (var i = 0; i < ethnicityObj.length; i++){
         ethnicityList.Items.push({ value:ethnicityObj[i].id , label:ethnicityObj[i].label  });
       }
     }

     //identity new object
     var identityList = {Items: [], SelectedValue: this.state.identitySelectedValue};
     if(data.Identities.Items.length>0){
       this.setState({isIdentity: true});
       var identityObj = data.Identities.Items;
       for (var i = 0; i < identityObj.length; i++){
         identityList.Items.push({ value:identityObj[i].id , label:identityObj[i].label  });
       }
     }

     //voiceType new object
     var voiceTypeList = {Items: [], SelectedValue: this.state.voiceTypeSelectedValue};
     var voiceTypeObj = data.VoiceTypes.Items;
     for (var i = 0; i < voiceTypeObj.length; i++){
       voiceTypeList.Items.push({ value:voiceTypeObj[i].id , label:voiceTypeObj[i].label  });
     }

     //languageAccent new object
     var languageAccentList = {Items: [], SelectedValue: this.state.languageAccent};
     if(data.LanguageAccents.Items.length>0){
       this.setState({isAccent: true});
       var languageAccentObj = data.LanguageAccents.Items;
       for (var i = 0; i < languageAccentObj.length; i++){
         languageAccentList.Items.push({ value:languageAccentObj[i].id , label:languageAccentObj[i].label  });
       }
     }

     //union new object voiceActor
     var unionList = {Items: [], SelectedValue: this.state.voiceActorUnionSelectedValue};
     if(data.Unions.Items.length>0){
       this.setState({isUnion: true});
       var unionObj = data.Unions.Items;
       for (var i = 0; i < unionObj.length; i++){
         unionList.Items.push({ value:unionObj[i].id , label:unionObj[i].label  });
       }
     }

     //union new object singer
     var unionListSinger = {Items: [], SelectedValue: this.state.singerUnionSelectedValue};
     if(data.Unions.Items.length>0){
       var unionObj = data.Unions.Items;
       for (var i = 0; i < unionObj.length; i++){
         unionListSinger.Items.push({ value:unionObj[i].id , label:unionObj[i].label  });
       }
       this.setState({isSingerUnion: true});
     }

     //region new object
     var regionList = {Items: [], SelectedValue: this.state.regionSelectedValue};
     if(data.Regions.Items.length>0){
       this.setState({isRegions: true});
       var regionObj = data.Regions.Items;
       for (var i = 0; i < regionObj.length; i++){
         regionList.Items.push({ value:regionObj[i].id , label:regionObj[i].label  });
       }
     }

     //director app access new object
     var directorAppAccess = {Items: [], SelectedValue: this.state.directorAppAccess};
     directorAppAccess.Items = [
       {value: 1, label: 'Enabled'},
       {value: 0, label: 'Disabled'}
     ]

     this.props.setSkillVendorSearchDropdownOptions(
        skillTypeList,
        skillLevelList,
        ageFromList,
        ageToList,
        cityList,
        schoolList,
        nativeLanguageList,
        experienceList,
        remoteRecordingList,
        genderList,
        statusList,
        numberOfAdaptionsRangeList,
        numberOfSongsWrittenRangeList,
        numberOfTranslationsRangeList,
        universityDegreeList,
        vocalRangeList,
        musicNotesReadingLevelList,
        voiceAgeRangeList,
        countryList,
        ethnicityList,
        identityList,
        voiceTypeList,
        languageAccentList,
        unionList,
        regionList,
        remoteRecordingDirector,
        remoteRecordingListLyricist,
        remoteRecordingListVoiceActor,
        remoteRecordingListSinger,
        remoteRecordingEditor,
        remoteRecordingListSoundEngineer,
        universityDegreeListAdaptor,
        universityDegreeListLyricist,
        voiceAgeRangeListSinger,
        unionListSinger,
        directorAppAccess
      );
   });
 }

  componentDidMount() {
    //set prop to clear fields
    //currently commented?
    //this.props.clear(this.onClearFields);

    this.getListsFromSkillVendorSearch();

    //set methods from parent to call in child
    this.props.setClickLoadFilterList(this.loadFilterList);
    this.props.setClickSaveAsFilterList(this.saveAsFilterList);
    this.props.setClickremoveFilterList(this.removeFilterList);
    this.props.setClickupdateFilterList(this.updateFilterList);
    this.props.setClickCleanSearchForm(this.cleanSearchForm);


  }

 loadFilterList() {
    this.toggleFilterListModal();

    this.props.ajax.get("talents-filter/filter?Skip=0&Take=0", true, (data) => {
      this.setState({filterList: data.Collection});
    }, true);
  }

  saveAsFilterList(){
    this.toggleFilterModal();
  }


  toggleFilterModal(){
    this.setState({filterModal:!this.state.filterModal})
  }

  toggleFilterListModal(){
    this.setState({filterListModal:!this.state.filterListModal})
  }

  saveFilterList(){
    if(this.state.filterListName == ''){
      this.setState({ filterListNameError: "Filter preset name is requiredd." });
      return false;
    }

    this.setState({ filterListNameError: '' });

    let data = this.state.dataSearch;



    let filterSearch = {
      "SkillVendorSearchQuery": {
        "Items": this.props.itemsForFilter,
        "FullTextSearch": this.props.fullTextSearchForFilter?this.props.fullTextSearchForFilter:''
      },
      "Name": this.state.filterListName
    }


    this.props.ajax.post(
      'talents-filter/create',
      JSON.stringify(filterSearch),
      {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }
      },
      (responseId) => {
          if(responseId){
            //callback method for set listFilterId
            this.props.sendFilterListId(responseId);
            this.setState({
              //selectedFilterListName: listFilterName,
              selectedFilterListId:responseId
            });
            this.toggleFilterModal();
            this.props.notify("Saved succefully");
          }
          else{
            this.toggleFilterModal();
            alert("Error: could not save filter");
          }
      }, true)
  }

  changeFilterListName(e){
    this.setState({filterListName:e.target.value});
    this.props.sendFilterListName(e.target.value);

  }

  handleFilterList(e){
    //here change
    if(this.state.selectedFilterList){
      this.setState({clear:true});
      setTimeout(() => this.onClearFields(), 50);
      //setTimeout(() => this.setState({clear:false}), 50);
      //reset inputSearch value
      this.props.clearInputSearch()
      //setTimeout(() => this.props.onSearch(), 1000);
      //setTimeout(() => this.onClearFields(), 1000);
    }
    //end change

    let listFilterName = e.currentTarget.getAttribute("data-name");
    let listFilterId = e.currentTarget.getAttribute("data-id");


    this.setState({
      selectedFilterListName: listFilterName,
      selectedFilterListId:listFilterId
    });

    //callback method for set listFilterName
    this.props.sendFilterListName(listFilterName);

    // this.props.ajax.get('talents-filter/filter?Search=' + listFilterName + '&Skip=0&Take=' + getCountryDBcode() , true, (data) => {
    this.props.ajax.get('talents-filter/' + listFilterId , true, (data) => {
      //selectedFilterList is unused?
      this.setState({selectedFilterList: data});
      this.setFilters(data);
    }, true);

    this.toggleFilterListModal();

    this.getListsFromSkillVendorSearch();

  }

  removeFilterList = (e) => {
    let filterListId = this.state.selectedFilterListId;
    if(window.confirm("Remove this filter preset?")){
      this.props.ajax.delete('talents-filter/' + filterListId  +'/delete', null, null, (response) => {
        if(response.Error == 'Forbidden'){
          alert("You can't remove this filter preset, it belongs to another user");
          return false;
        }else{
          console.log('ok');
          this.props.notify(`Succefully removed.`);
          //remove save and remove option
          this.props.removeSelectedPresetFilter();
        }
        //clear search Perform
        this.clearSearch();
      });

    }else{

    }
  }

  updateFilterList = (e) => {
    let filterListId = this.state.selectedFilterListId;
    if(window.confirm("Update filter preset?")){
      let filterSearch = {
        "Items": this.props.itemsForFilter,
        "FullTextSearch": this.props.fullTextSearchForFilter?this.props.fullTextSearchForFilter:''
      }

      this.props.ajax.put(
        'talents-filter/' + filterListId  +'/update',
        JSON.stringify(filterSearch),
        {
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          }
        },
        (response) => {
          if (response.status === 200) {
            this.props.notify(`Filter list has been updated.`);
          }
          else{
            this.setState({
              errorMsg: `Can not update filter list`
            })
            alert('Error: can not update filter list`');
          }
        })
    }
  }


  cleanSearchForm = (e) => {
    this.clearSearch();

    this.props.removeSelectedPresetFilter();
  }

  setFilters(dataFromSelectedFilters){
    let data = dataFromSelectedFilters;
    let skillVendorSearchQuery = data.SkillVendorSearchQuery;

    let fullTextSearchForFilter = skillVendorSearchQuery.FullTextSearch;

    this.setState({fullTextSearchForFilter:fullTextSearchForFilter});
    //callback method for set fullTextSearchForFilter
    this.props.sendFullTextSearchForFilter(fullTextSearchForFilter);

    if(skillVendorSearchQuery.Items.length > 0){
      skillVendorSearchQuery.Items.map((criteria) => {
        //age from criteria
        if(criteria.SearchProperty == 3){
          let values = criteria.Values;

          let ageFromSelected = values[0].toString();
          this.setState({ageFromSelectedValue: ageFromSelected});

          let ageEndSelected = values.pop().toString();;

          this.setState({ageToSelectedValue: ageEndSelected});

        }

        //native language criteria
        if(criteria.SearchProperty == 9){
          let values = criteria.Values.toString();
          this.setState({nativeLanguageSelectedValue: values});
        }

        //additional language criteria
        if(criteria.SearchProperty == 10){
          let values = criteria.Values.toString();
          this.setState({additionalLanguagesSelectedValue: values});
        }

        //country criteria
        if(criteria.SearchProperty == 6){
          let values = criteria.Values.toString();
          this.setState({countrySelectedValue: values});
        }

        //city criteria
        if(criteria.SearchProperty == 7){
          let values = criteria.Values.toString();
          this.setState({citySelectedValue: values});
        }

        //region criteria
        if(criteria.SearchProperty == 16){
          let values = criteria.Values.toString();
          this.setState({regionSelectedValue: values});
        }

        //ethnicity criteria
        if(criteria.SearchProperty == 13){
          let values = criteria.Values.toString();
          this.setState({ethnicitySelectedValue: values});
        }

        //identity criteria
        if(criteria.SearchProperty == 14){
          let values = criteria.Values.toString();
          this.setState({identitySelectedValue: values});
        }

        //skillLevel criteria
        if(criteria.SearchProperty == 22){
          let values = criteria.Values.toString();
          this.setState({skillLevelSelectedValue: values});
        }

        //skillType criteria
        if(criteria.SearchProperty == 20){
          let values = criteria.Values.toString();
          this.setState({skillTypeSelectedValue: values})
        }


        //voiceAge criteria voiceActor
        if(criteria.SearchProperty == 2821){
          let values = criteria.Values.toString();
          this.setState({voiceAgeSelectedValue: values});
        }

        //voiceAge criteria singer
        if(criteria.SearchProperty == 2507){
          let values = criteria.Values.toString();
          this.setState({voiceAgeSelectedValue: values});
        }

        //voiceType criteria voiceActor
        if(criteria.SearchProperty == 2823){
          let values = criteria.Values.toString();
          this.setState({voiceTypeSelectedValue: values});
        }

        //doNotUse criteria
        if(criteria.SearchProperty == 4){
          this.setState({doNotUseSelectedValue: true});
        }

        //knownTalent criteria
        if(criteria.SearchProperty == 24){
          this.setState({knownTalentSelectedValue: true});
        }

        //skillVendorStatus criteria
        if(criteria.SearchProperty == 5){
          let values = criteria.Values;
          if(values[0] == 0){
              this.setState({skillVendorStatusCheckboxSelectedValue: true});
          }

        }

        //voice gender male live action criteria voiceActor
        if(criteria.SearchProperty == 2815){
          this.setState({liveActionVoiceGenderMale:true});
        }

        //voice gender female live action criteria voiceActor
        if(criteria.SearchProperty == 2816){
          this.setState({liveActionVoiceGenderFemale:true});
        }

        //voiceActorAnimationMaleVoiceGender
        if(criteria.SearchProperty == 2817){
          this.setState({voiceActorAnimationMaleVoiceGender:true});
        }

        //voiceActorAnimationFemaleVoiceGender
        if(criteria.SearchProperty == 2818){
          this.setState({voiceActorAnimationFemaleVoiceGender:true});
        }

        //VoiceActorTheatricalExperience
        if(criteria.SearchProperty == 2808){
          this.setState({voiceActorTheatricalExperience:true});
        }

        //VoiceActorTVExperience
        if(criteria.SearchProperty == 2809){
          this.setState({voiceActorTVExperience:true});
        }

        //voiceActorVideoGamesExperience
        if(criteria.SearchProperty == 2810){
          this.setState({voiceActorVideoGamesExperience:true});
        }

        //voiceActorPromoOrCommercialsExperience
        if(criteria.SearchProperty == 2811){
          this.setState({voiceActorPromoOrCommercialsExperience:true});
        }

        //voiceActorLiveActionExperience
        if(criteria.SearchProperty == 2812){
          this.setState({voiceActorLiveActionExperience:true});
        }

        //voiceActorAnimationExperience
        if(criteria.SearchProperty == 2813){
          this.setState({voiceActorAnimationExperience:true});
        }

        //voiceActorDubbingExperience
        if(criteria.SearchProperty == 2801){
          this.setState({voiceActorDubbingExperience:true});
        }

        //voiceActorAudiobooksExperience
        if(criteria.SearchProperty == 2802){
          this.setState({voiceActorAudiobooksExperience:true});
        }

        //voiceActorVoiceOverExperience
        if(criteria.SearchProperty == 2803){
          this.setState({voiceActorVoiceOverExperience:true});
        }

        //voiceActorRadioExperience
        if(criteria.SearchProperty == 2804){
          this.setState({voiceActorRadioExperience:true});
        }

        //voiceActorTheatreActorExperience
        if(criteria.SearchProperty == 2805){
          this.setState({voiceActorTheatreActorExperience:true});
        }

        //voiceActorMovieActorExperience
        if(criteria.SearchProperty == 2806){
          this.setState({voiceActorMovieActorExperience:true});
        }

        //voiceActorAudioDescriptionExperience
        if(criteria.SearchProperty == 2807){
          this.setState({voiceActorAudioDescriptionExperience:true});
        }


        //voiceactor studio
        if(criteria.SearchProperty == 2819){
          let values = criteria.Values.toString();
          this.setState({voiceActorStudio:values});
        }

        //voiceactor client
        if(criteria.SearchProperty == 2820){
          let values = criteria.Values.toString();
          this.setState({voiceActorClient:values});
        }

        //voiceactor school
        if(criteria.SearchProperty == 2826){
          let values = criteria.Values.toString();
          this.setState({voiceActorSchool:values});
        }

        //voiceactor languageAccent
        if(criteria.SearchProperty == 2822){
          let values = criteria.Values.toString();
          this.setState({languageAccent:values});
        }

        //voiceactor remoteRecording
        if(criteria.SearchProperty == 2814){
          let values = criteria.Values.toString();
          this.setState({remoteRecordingListVoiceActorSelectedValue:values});
        }

        //voiceactor union
        if(criteria.SearchProperty == 2824){
          let values = criteria.Values.toString();
          this.setState({voiceActorUnionSelectedValue:values});
        }

        //voiceActorGenderNeutralVoice
        if(criteria.SearchProperty == 2825){
          this.setState({voiceActorGenderNeutralVoice:true});
        }

        //peoduction cast
        if(criteria.SearchProperty == 17){
          let values = criteria.Values.toString();
          this.setState({productionCast:values});
        }

        //externalExperience cast
        if(criteria.SearchProperty == 19){
          let values = criteria.Values.toString();
          this.setState({externalExperienceCast:values});
        }

        //vacancy cast
        if(criteria.SearchProperty == 18){
          let values = criteria.Values.toString();
          this.setState({vacancyCast:values});
        }

        //booker theatrical
        if(criteria.SearchProperty == 2101){
          this.setState({bookerTheatricalExperience:true});
        }

        //booker tv
        if(criteria.SearchProperty == 2102){
          this.setState({bookerTVExperience:true});
        }

        //booker interactive
        if(criteria.SearchProperty == 2103){
          this.setState({bookerInteractiveExperience:true});
        }

        //booker studio
        if(criteria.SearchProperty == 2104){
          let values = criteria.Values.toString();
          this.setState({bookerStudio:values});
        }

        //director dubbing director
        if(criteria.SearchProperty == 2201){
          this.setState({directorDubbingDirectorExperience:true});
        }

        //director v/o director
        if(criteria.SearchProperty == 2202){
          this.setState({directorVoiceOverDirectorExperience:true});
        }

        //director song director
        if(criteria.SearchProperty == 2203){
          this.setState({directorSongDirectorExperience:true});
        }

        //director dubbing director
        if(criteria.SearchProperty == 2204){
          this.setState({directorDubbingActorExperience:true});
        }

        //director stage director
        if(criteria.SearchProperty == 2205){
          this.setState({directorStageDirectorExperience:true});
        }

        //director movie director experience
        if(criteria.SearchProperty == 2206){
          this.setState({directorMovieDirectorExperience:true});
        }

        //director theatrical experience
        if(criteria.SearchProperty == 2207){
          this.setState({directorTheatricalExperience:true});
        }

        //director tv experience
        if(criteria.SearchProperty == 2208){
          this.setState({directorTVExperience:true});
        }

        //director games experience
        if(criteria.SearchProperty == 2209){
          this.setState({directorGamesExperience:true});
        }

        //director promo Commercials experience
        if(criteria.SearchProperty == 2210){
          this.setState({directorPromoOrCommercialsExperience:true});
        }

        //director live action  experience
        if(criteria.SearchProperty == 2211){
          this.setState({directorLiveActionExperience:true});
        }

        //directorVideoGamesExperience
        if(criteria.SearchProperty == 2209){
          this.setState({directorVideoGamesExperience:true});
        }

        //directorPromoCommercialsExperience
        if(criteria.SearchProperty == 2210){
          this.setState({directorPromoCommercialsExperience:true});
        }

        //director  animation  experience
        if(criteria.SearchProperty == 2212){
          this.setState({directorAnimationExperience:true});
        }

        //director  audio description  experience
        if(criteria.SearchProperty == 2213){
          this.setState({directorAudioDescriptionExperience:true});
        }

        //director  directorRemoteRecording
        if(criteria.SearchProperty == 2214){
          let values = criteria.Values.toString()
          this.setState({remoteRecordingDirectorSelectedValue:values});
        }

        //director  app access
        if(criteria.SearchProperty == 2215){
          let values = criteria.Values.toString();
          this.setState({directorAppAccess:values});
        }

        //director  studio
        if(criteria.SearchProperty == 2216){
          let values = criteria.Values.toString();
          this.setState({directorStudio:values});
        }

        //director  client
        if(criteria.SearchProperty == 2217){
          let values = criteria.Values.toString();
          this.setState({directorClient:values});
        }

        //director school
        if(criteria.SearchProperty == 2218){
          let values = criteria.Values.toString();
          this.setState({directorSchool:values});
        }

        //singer singerMaleVoiceGender
        if(criteria.SearchProperty == 2509){
          this.setState({singerMaleVoiceGender:true});
        }

        //singer singerFemaleVoiceGender
        if(criteria.SearchProperty == 2510){
          this.setState({singerFemaleVoiceGender:true});
        }

        //singer vocalRangeSingerSelectedValue
        if(criteria.SearchProperty == 2506){
          let values = criteria.Values.toString();
          this.setState({vocalRangeSingerSelectedValue:values});
        }

        //singer voiceAgeSingerSelectedValue
        if(criteria.SearchProperty == 2508){
          let values = criteria.Values.toString();
          this.setState({voiceAgeSingerSelectedValue:values});
        }

        //singer readingMusicNoteSingerSelectedValue
        if(criteria.SearchProperty == 2507){
          let values = criteria.Values.toString();
          this.setState({readingMusicNoteSingerSelectedValue:values});
        }


        //singer singerDubbingExperience
        if(criteria.SearchProperty == 2501){
          this.setState({singerDubbingExperience:true});
        }

        //singer singerStageExperience
        if(criteria.SearchProperty == 2502){
          this.setState({singerStageExperience:true});
        }

        //singer singerTheatreExperience
        if(criteria.SearchProperty == 2503){
          this.setState({singerTheatreExperience:true});
        }

        //singer singerTalentShowExperience
        if(criteria.SearchProperty == 2505){
          this.setState({singerTalentShowExperience:true});
        }

        //singer studio
        if(criteria.SearchProperty == 2511){
          let values = criteria.Values.toString();
          this.setState({singerStudio:values});
        }

        //singer client
        if(criteria.SearchProperty == 2512){
          let values = criteria.Values.toString();
          this.setState({singerClient:values});
        }

        //singer school
        if(criteria.SearchProperty == 2515){
          let values = criteria.Values.toString();
          this.setState({singerSchool:values});
        }

        //singer remoteRecording
        if(criteria.SearchProperty == 2504){
          let values = criteria.Values.toString();
          this.setState({remoteRecordingSingerSelectedValue:values});
        }

        //singer union
        if(criteria.SearchProperty == 2513){
          let values = criteria.Values.toString();
          this.setState({singerUnionSelectedValue:values});
        }

        //singerGenderNeutralVoice
        if(criteria.SearchProperty == 2514){
          this.setState({singerGenderNeutralVoice:true});
        }

        //lyricistMusicalExperience
        if(criteria.SearchProperty == 2406){
          this.setState({lyricistMusicalExperience:true});
        }

        //lyricistTheatreExperience
        if(criteria.SearchProperty == 2407){
          this.setState({lyricistTheatreExperience:true});
        }

        //lyricistPromoCommercialsExperience
        if(criteria.SearchProperty == 2408){
          this.setState({lyricistPromoCommercialsExperience:true});
        }

        //lyricistExperience
        if(criteria.SearchProperty == 2401){
          this.setState({lyricistExperience:true});
        }

        //lyricistDubbingExperience
        if(criteria.SearchProperty == 2402){
          this.setState({lyricistDubbingExperience:true});
        }

        //lyricistMusicianExperience
        if(criteria.SearchProperty == 2403){
          this.setState({lyricistMusicianExperience:true});
        }

        //lyricistNumberOfSongsWritten
        if(criteria.SearchProperty == 2404){
          let values = criteria.Values.toString();
          this.setState({lyricistNumberOfSongsWritten:values});
        }

        //lyricistUniversityDegree
        if(criteria.SearchProperty == 2409){
          let values = criteria.Values.toString();
          this.setState({lyricistUniversityDegree:values});
        }

        //lyricistStudio
        if(criteria.SearchProperty == 2410){
          let values = criteria.Values.toString();
          this.setState({lyricistStudio:values});
        }

        //lyricistClient
        if(criteria.SearchProperty == 2411){
          let values = criteria.Values.toString();
          this.setState({lyricistClient:values});
        }

        //lyricist remoteRecording
        if(criteria.SearchProperty == 2405){
          let values = criteria.Values.toString();
          this.setState({remoteRecordingLyricistSelectedValue:values});
        }

        //translatorTheatricalExperience
        if(criteria.SearchProperty == 2709){
          this.setState({translatorTheatricalExperience:true});
        }

        //translatorTVExperience
        if(criteria.SearchProperty == 2710){
          this.setState({translatorTVExperience:true});
        }

        //translatorGamesExperience
        if(criteria.SearchProperty == 2711){
          this.setState({translatorGamesExperience:true});
        }

        //translatorPromoOrCommercialsExperience
        if(criteria.SearchProperty == 2712){
          this.setState({translatorPromoOrCommercialsExperience:true});
        }

        //translatorLiveActionExperience
        if(criteria.SearchProperty == 2713){
          this.setState({translatorLiveActionExperience:true});
        }

        //translatorAnimationExperience
        if(criteria.SearchProperty == 2714){
          this.setState({translatorAnimationExperience:true});
        }

        //translatorSubtitlesExperience
        if(criteria.SearchProperty == 2701){
          this.setState({translatorSubtitlesExperience:true});
        }

        //translatorDubbingExperience
        if(criteria.SearchProperty == 2702){
          this.setState({translatorDubbingExperience:true});
        }

        //translatorVoiceOverExperience
        if(criteria.SearchProperty == 2703){
          this.setState({translatorVoiceOverExperience:true});
        }

        //translatorGamingExperience
        if(criteria.SearchProperty == 2704){
          this.setState({translatorGamingExperience:true});
        }


        //translatorAudioDescriptionExperience
        if(criteria.SearchProperty == 2705){
          this.setState({translatorAudioDescriptionExperience:true});
        }

        //translatorHOHSDHCCExperience
        if(criteria.SearchProperty == 2706){
          this.setState({translatorHOHSDHCCExperience:true});
        }

        //translatorNumberOfTranslations
        if(criteria.SearchProperty == 2708){
          let values = criteria.Values.toString();
          this.setState({translatorNumberOfTranslations:values});
        }

        //translatorUniversityDegree
        if(criteria.SearchProperty == 2715){
          let values = criteria.Values.toString();
          this.setState({translatorUniversityDegree:values});
        }

        //translatorStudios
        if(criteria.SearchProperty == 2716){
          let values = criteria.Values.toString();
          this.setState({translatorStudios:values});
        }

        //translatorClients
        if(criteria.SearchProperty == 2717){
          let values = criteria.Values.toString();
          this.setState({translatorClients:values});
        }


        //editorDubbingExperience
        if(criteria.SearchProperty == 2306){
          this.setState({editorDubbingExperience:true});
        }

        //editorVoiceOverExperience
        if(criteria.SearchProperty == 2307){
          this.setState({editorVoiceOverExperience:true});
        }

        //editorSongsExperience
        if(criteria.SearchProperty == 2308){
          this.setState({editorSongsExperience:true});
        }

        //editorProToolsExperience
        if(criteria.SearchProperty == 2309){
          this.setState({editorProToolsExperience:true});
        }

        //editorDolby51Experience
        if(criteria.SearchProperty == 2310){
          this.setState({editorDolby51Experience:true});
        }

        //editorAtmosExperience
        if(criteria.SearchProperty == 2311){
          this.setState({editorAtmosExperience:true});
        }

        //editorFoleyExperience
        if(criteria.SearchProperty == 2312){
          this.setState({editorFoleyExperience:true});
        }

        //editorRecordingEditingExperience
        if(criteria.SearchProperty == 2301){
          this.setState({editorRecordingEditingExperience:true});
        }

        //editorDialogueEditingExperience
        if(criteria.SearchProperty == 2302){
          this.setState({editorDialogueEditingExperience:true});
        }

        //editorMusicAndEffectsExperience
        if(criteria.SearchProperty == 2303){
          this.setState({editorMusicAndEffectsExperience:true});
        }

        //editorMixEditingExperience
        if(criteria.SearchProperty == 2304){
          this.setState({editorMixEditingExperience:true});
        }

        //editorPreparingTakesExperience
        if(criteria.SearchProperty == 2305){
          this.setState({editorPreparingTakesExperience:true});
        }

        //editorAudioDescriptionExperience
        if(criteria.SearchProperty == 2313){
          this.setState({editorAudioDescriptionExperience:true});
        }

        //editorStudios
        if(criteria.SearchProperty == 2315){
          let values = criteria.Values.toString();
          this.setState({editorStudios:values});
        }

        //editorClients
        if(criteria.SearchProperty == 2316){
          let values = criteria.Values.toString();
          this.setState({editorClients:values});
        }

        //editorSchools
        if(criteria.SearchProperty == 2317){
          let values = criteria.Values.toString();
          this.setState({editorSchools:values});
        }

        //editorRemoteRecording
        if(criteria.SearchProperty == 2314){
          let values = criteria.Values.toString();
          this.setState({editorRemoteRecordingCapability:values});
        }



        //adaptorTheatricalExperience
        if(criteria.SearchProperty == 2005){
          this.setState({adaptorTheatricalExperience:true});
        }

        //adaptorTVExperience
        if(criteria.SearchProperty == 2006){
          this.setState({adaptorTVExperience:true});
        }

        //adaptorGamesExperience
        if(criteria.SearchProperty == 2007){
          this.setState({adaptorGamesExperience:true});
        }

        //adaptorPromoOrCommercialsExperience
        if(criteria.SearchProperty == 2008){
          this.setState({adaptorPromoOrCommercialsExperience:true});
        }

        //adaptorLiveActionExperience
        if(criteria.SearchProperty == 2009){
          this.setState({adaptorLiveActionExperience:true});
        }

        //adaptorAnimationExperience
        if(criteria.SearchProperty == 2010){
          this.setState({adaptorAnimationExperience:true});
        }

        //adaptorAdaptorExperience
        if(criteria.SearchProperty == 2001){
          this.setState({adaptorAdaptorExperience:true});
        }

        //adaptorDubbingDirectorExperience
        if(criteria.SearchProperty == 2002){
          this.setState({adaptorDubbingDirectorExperience:true});
        }

        //adaptorTranslatorExperience
        if(criteria.SearchProperty == 2003){
          this.setState({adaptorTranslatorExperience:true});
        }

        //adaptorVoiceActorExperience
        if(criteria.SearchProperty == 2004){
          this.setState({adaptorVoiceActorExperience:true});
        }

        //adaptorAudioDescriptionExperience
        if(criteria.SearchProperty == 2011){
          this.setState({adaptorAudioDescriptionExperience:true});
        }

        //adaptorNumberOfAdaptionsRange
        if(criteria.SearchProperty == 2012){
          let values = criteria.Values.toString();
          this.setState({adaptorNumberOfAdaptionsRange:values});
        }

        //adaptorUniversityDegree
        if(criteria.SearchProperty == 2013){
          let values = criteria.Values.toString();
          this.setState({adaptorUniversityDegree:values});
        }

        //adaptorStudios
        if(criteria.SearchProperty == 2014){
          let values = criteria.Values.toString();
          this.setState({adaptorStudios:values});
        }

        //adaptorClients
        if(criteria.SearchProperty == 2015){
          let values = criteria.Values.toString();
          this.setState({adaptorClients:values});
        }

        //soundEngineerDubbingExperience
        if(criteria.SearchProperty == 2607){
          this.setState({soundEngineerDubbingExperience:true});
        }

        //soundEngineerVoiceOverExperience
        if(criteria.SearchProperty == 2608){
          this.setState({soundEngineerVoiceOverExperience:true});
        }

        //soundEngineerSongsExperience
        if(criteria.SearchProperty == 2609){
          this.setState({soundEngineerSongsExperience:true});
        }

        //soundEngineerProToolsExperience
        if(criteria.SearchProperty == 2610){
          this.setState({soundEngineerProToolsExperience:true});
        }

        //soundEngineerDolby51Experience
        if(criteria.SearchProperty == 2611){
          this.setState({soundEngineerDolby51Experience:true});
        }

        //soundEngineerAtmosExperience
        if(criteria.SearchProperty == 2612){
          this.setState({soundEngineerAtmosExperience:true});
        }

        //soundEngineerFoleyExperience
        if(criteria.SearchProperty == 2613){
          this.setState({soundEngineerFoleyExperience:true});
        }

        //soundEngineerDialogueRecordingExperience
        if(criteria.SearchProperty == 2601){
          this.setState({soundEngineerDialogueRecordingExperience:true});
        }

        //soundEngineerSongRecordingExperience
        if(criteria.SearchProperty == 2602){
          this.setState({soundEngineerSongRecordingExperience:true});
        }

        //soundEngineerDialogueMixingExperience
        if(criteria.SearchProperty == 2603){
          this.setState({soundEngineerDialogueMixingExperience:true});
        }


        //soundEngineerSongMixingExperience
        if(criteria.SearchProperty == 2604){
          this.setState({soundEngineerSongMixingExperience:true});
        }

        //soundEngineerAudioDescriptionMixingExperience
        if(criteria.SearchProperty == 2605){
          this.setState({soundEngineerAudioDescriptionMixingExperience:true});
        }

        //soundEngineerStudios
        if(criteria.SearchProperty == 2614){
          let values = criteria.Values.toString();
          this.setState({soundEngineerStudios:values});
        }

        //soundEngineerClients
        if(criteria.SearchProperty == 2615){
          let values = criteria.Values.toString();
          this.setState({soundEngineerClients:values});
        }

        //soundEngineerSchools
        if(criteria.SearchProperty == 2616){
          let values = criteria.Values.toString();
          this.setState({soundEngineerSchools:values});
        }

        //soundEngineerRemoteRecordingCapability
        if(criteria.SearchProperty == 2606){
          let values = criteria.Values.toString();
          this.setState({soundEngineerRemoteRecordingCapability:values});
        }

        //adaptorDoNotUse
        if(criteria.SearchProperty == 2017){
          this.setState({adaptorDoNotUse:true});
        }

        //bookerDoNotUse
        if(criteria.SearchProperty == 2107){
          this.setState({bookerDoNotUse:true});
        }

        //directorDoNotUse
        if(criteria.SearchProperty == 2219){
          this.setState({directorDoNotUse:true});
        }

        //editorDoNotUse
        if(criteria.SearchProperty == 2318){
          this.setState({editorDoNotUse:true});
        }

        //lyricistDoNotUse
        if(criteria.SearchProperty == 2413){
          this.setState({lyricistDoNotUse:true});
        }

        //singerDoNotUse
        if(criteria.SearchProperty == 2516){
          this.setState({singerDoNotUse:true});
        }

        //soundEngineerDoNotUse
        if(criteria.SearchProperty == 2617){
          this.setState({soundEngineerDoNotUse:true});
        }

        //translatorDoNotUse
        if(criteria.SearchProperty == 2719){
          this.setState({translatorDoNotUse:true});
        }

        //voiceActorDoNotUse
        if(criteria.SearchProperty == 2827){
          this.setState({voiceActorDoNotUse:true});
        }


      })
    }

    this.props.setSkillVendorSearchCheckboxValue(
      this.state.knownTalentSelectedValue,
      this.state.doNotUseSelectedValue,
      this.state.skillVendorStatusSelectedValue,
      this.state.liveActionVoiceGenderMale,
      this.state.liveActionVoiceGenderFemale,
      this.state.voiceActorTheatricalExperience,
      this.state.voiceActorTVExperience,
      this.state.voiceActorVideoGamesExperience,
      this.state.voiceActorPromoOrCommercialsExperience,
      this.state.voiceActorAnimationMaleVoiceGender,
      this.state.voiceActorAnimationFemaleVoiceGender,
      this.state.voiceActorLiveActionExperience,
      this.state.voiceActorAnimationExperience,
      this.state.voiceActorDubbingExperience,
      this.state.voiceActorAudiobooksExperience,
      this.state.voiceActorVoiceOverExperience,
      this.state.voiceActorRadioExperience,
      this.state.voiceActorTheatreActorExperience,
      this.state.voiceActorMovieActorExperience,
      this.state.voiceActorAudioDescriptionExperience,
      this.state.bookerTheatricalExperience,
      this.state.bookerTVExperience,
      this.state.bookerInteractiveExperience,
      this.state.singerMaleVoiceGender,
      this.state.singerFemaleVoiceGender,
      this.state.singerDubbingExperience,
      this.state.singerStageExperience,
      this.state.singerTheatreExperience,
      this.state.singerTalentShowExperience,
      this.state.directorTheatricalExperience,
      this.state.directorTVExperience,
      this.state.directorGamesExperience,
      this.state.directorPromoOrCommercialsExperience,
      this.state.directorLiveActionExperience,
      this.state.directorAnimationExperience,
      this.state.directorDubbingDirectorExperience,
      this.state.directorVoiceOverDirectorExperience,
      this.state.directorSongDirectorExperience,
      this.state.directorDubbingActorExperience,
      this.state.directorStageDirectorExperience,
      this.state.directorMovieDirectorExperience,
      this.state.directorAudioDescriptionExperience,
      this.state.lyricistMusicalExperience,
      this.state.lyricistTheatreExperience,
      this.state.lyricistPromoCommercialsExperience,
      this.state.lyricistExperience,
      this.state.lyricistDubbingExperience,
      this.state.lyricistMusicianExperience,
      this.state.translatorTheatricalExperience,
      this.state.translatorTVExperience,
      this.state.translatorGamesExperience,
      this.state.translatorPromoOrCommercialsExperience,
      this.state.translatorLiveActionExperience,
      this.state.translatorAnimationExperience,
      this.state.translatorSubtitlesExperience,
      this.state.translatorDubbingExperience,
      this.state.translatorVoiceOverExperience,
      this.state.translatorGamingExperience,
      this.state.translatorAudioDescriptionExperience,
      this.state.translatorHOHSDHCCExperience,
      this.state.editorDubbingExperience,
      this.state.editorVoiceOverExperience,
      this.state.editorSongsExperience,
      this.state.editorProToolsExperience,
      this.state.editorDolby51Experience,
      this.state.editorAtmosExperience,
      this.state.editorFoleyExperience,
      this.state.editorRecordingEditingExperience,
      this.state.editorDialogueEditingExperience,
      this.state.editorMusicAndEffectsExperience,
      this.state.editorMixEditingExperience,
      this.state.editorPreparingTakesExperience,
      this.state.editorAudioDescriptionExperience,
      this.state.adaptorTheatricalExperience,
      this.state.adaptorTVExperience,
      this.state.adaptorGamesExperience,
      this.state.adaptorPromoOrCommercialsExperience,
      this.state.adaptorLiveActionExperience,
      this.state.adaptorAnimationExperience,
      this.state.adaptorAdaptorExperience,
      this.state.adaptorDubbingDirectorExperience,
      this.state.adaptorTranslatorExperience,
      this.state.adaptorVoiceActorExperience,
      this.state.adaptorAudioDescriptionExperience,
      this.state.soundEngineerDubbingExperience,
      this.state.soundEngineerVoiceOverExperience,
      this.state.soundEngineerSongsExperience,
      this.state.soundEngineerProToolsExperience,
      this.state.soundEngineerDolby51Experience,
      this.state.soundEngineerAtmosExperience,
      this.state.soundEngineerFoleyExperience,
      this.state.soundEngineerDialogueRecordingExperience,
      this.state.soundEngineerSongRecordingExperience,
      this.state.soundEngineerDialogueMixingExperience,
      this.state.soundEngineerSongMixingExperience,
      this.state.soundEngineerAudioDescriptionMixingExperience,
      this.state.singerGenderNeutralVoice,
      this.state.voiceActorGenderNeutralVoice,
      this.state.adaptorDoNotUse,
      this.state.bookerDoNotUse,
      this.state.directorDoNotUse,
      this.state.editorDoNotUse,
      this.state.singerDoNotUse,
      this.state.lyricistDoNotUse,
      this.state.soundEngineerDoNotUse,
      this.state.translatorDoNotUse,
      this.state.voiceActorDoNotUse,
      this.state.skillVendorStatusCheckboxSelectedValue
    );

    //here should be search function with sleep
    setTimeout(() => this.props.onSearch(), 3000);
    //this.props.onSearch();
  }


  clearSearch(){
    this.setState({clear:true});
    setTimeout(() => this.props.onSearch(), 1000);
    //currently commented?
    //setTimeout(() => this.setState({clear:false}), 2000);
    // setTimeout(() => this.setState({
    //   selectedFilterList:'',
    //
    //   editorStudios:'',
    //   editorClients:'',
    //   editorSchools:'',
    //   skillTypeId:''
    // }), 1000);
    setTimeout(() => this.onClearFields(), 1000);
    //reset inputSearch value
    this.props.clearInputSearch()

    // setTimeout(() => this.props.onSearch(), 3000);
    //this.setState({clear:false});
    //console.log(this.state.clear);
  }
  render() {
    //console.log(this.state.selectedFilterList);
    let arrowIconAdaptor = this.state.collapseAdaptor ? 'keyboard_arrow_down' : 'keyboard_arrow_up';
    let arrowIconBooker = this.state.collapseBooker ? 'keyboard_arrow_down' : 'keyboard_arrow_up';
    let arrowIconDirector = this.state.collapseDirector ? 'keyboard_arrow_down' : 'keyboard_arrow_up';
    let arrowIconEditor = this.state.collapseEditor ? 'keyboard_arrow_down' : 'keyboard_arrow_up';
    let arrowIconLyricist = this.state.collapseLyricist ? 'keyboard_arrow_down' : 'keyboard_arrow_up';
    let arrowIconSinger = this.state.collapseSinger ? 'keyboard_arrow_down' : 'keyboard_arrow_up';
    let arrowIconSoundEngineer = this.state.collapseSoundEngineer ? 'keyboard_arrow_down' : 'keyboard_arrow_up';
    let arrowIconTranslator = this.state.collapseTranslator ? 'keyboard_arrow_down' : 'keyboard_arrow_up';
    let arrowIconVoiceActor = this.state.collapseVoiceActor ? 'keyboard_arrow_down' : 'keyboard_arrow_up';
    let arrowIconProductions = this.state.collapseProductions ? 'keyboard_arrow_down' : 'keyboard_arrow_up';
    let arrowIconBasicDetails = this.state.collapseBasicDetails ? 'keyboard_arrow_down' : 'keyboard_arrow_up';
    let fields = this.props.fields;


    //inputSearch value
    fields[0].value = this.props.inputSearch;

    //skillVendorStatus, set defaultValue
    fields[11].defaultValue = 10;


    return (
      <SingleLineSearchForm fields={fields} onSearch={this.props.onSearch}>
      <Modal
        isOpen={this.state.filterModal}
        toggle={this.toggle}
        wrapClassName="modal-primary"
        size={'default'}>
        <ModalHeader>Save filter preset</ModalHeader>
        <ModalBody>
          <div className="form-group">
            <label>Filter preset name</label>
            <input onChange={this.changeFilterListName.bind(this)} name="filter-list-name" type="text" className="form-control"/>
            {this.state.filterListNameError && <div className="form-text text-danger mb-2">{this.state.filterListNameError}</div>}
          </div>
        </ModalBody>
        <ModalFooter>
          <button className="btn btn-primary btn-rounded" onClick={this.saveFilterList.bind(this)}>
            Save
          </button>
          <button className="btn btn-default btn-rounded" onClick={this.toggleFilterModal.bind(this)}>
            Close
          </button>
        </ModalFooter>
      </Modal>

      <Modal
        isOpen={this.state.filterListModal}
        toggle={this.toggle}
        wrapClassName="modal-primary"
        size={'default'}>
        <ModalHeader>Filter preset</ModalHeader>
        <ModalBody>
        {this.state.filterList &&
          <div className="col">
            <ul className={this.state.filterList.length>10 ? 'filter-list-scroll' : 'filter-list'}>
              {this.state.filterList.map((filter, key) => {
                return <li key={key}>
                  <a onClick={(e) => this.handleFilterList(e)} data-name={filter.Name} data-id={filter.Id}>{filter.Name}</a>
                  <br/></li>
              })}
            </ul>
          </div>
        }
        </ModalBody>
        <ModalFooter>
          <button className="btn btn-default btn-rounded" onClick={this.toggleFilterListModal.bind(this)}>
            Close
          </button>
        </ModalFooter>
      </Modal>
        <div className="talent-search">
            <div className="row">
              <div className="col-11">
                <MultiSelect field={fields[1]} clear={this.state.clear} validate={this.props.validateSkillVendorSearchField} search={this.props.onSearch} />
              </div>
            </div>
            <div className="row">
              <div className="col-11">
                <MultiSelect field={fields[2]} clear={this.state.clear} validate={this.props.validateSkillVendorSearchField} search={this.props.onSearch} />
              </div>
            </div>
            <div>
                <a type="button" className="btn btn-primary btn-flat btn-icon" onClick={this.toggleBasicDetails}>
                  <i className="material-icons">{arrowIconBasicDetails}</i>
                  <span>Personal & basic info {this.props.personalCounter?'(' + this.props.personalCounter + ')':''}</span>
                </a>
                <Collapse isOpen={this.state.collapseBasicDetails} className="mb-4">
                   <Card>
                       <CardBody>
                         <div className="row">
                           <div className="col-11">
                             <ReactSelectTalentSearch clear={this.state.clear} field={fields[5]} validate={this.props.validateSkillVendorSearchField} search={this.props.onSearch} />
                           </div>
                         </div>
                         <div className="row">
                           <div className="col-11">
                             <MultiSelect field={fields[6]} clear={this.state.clear} validate={this.props.validateSkillVendorSearchField} search={this.props.onSearch}/>
                           </div>
                         </div>
                         <div className="row">
                           <div className="col-5">
                             <ReactSelectTalentSearch clear={this.state.clear} field={fields[3]} validate={this.props.validateSkillVendorSearchField} search={this.props.onSearch}/>
                           </div>
                           <div className="col-1"></div>
                           <div className="col-5">
                             <ReactSelectTalentSearch clear={this.state.clear} field={fields[4]} validate={this.props.validateSkillVendorSearchField} search={this.props.onSearch}/>
                           </div>
                         </div>
                         <div className="row">
                           <div className="col-11">
                             <MultiSelect field={fields[7]} clear={this.state.clear} validate={this.props.validateSkillVendorSearchField} search={this.props.onSearch}/>
                           </div>
                          </div>
                         <div className="row">
                           <div className="col-11">
                             <MultiSelect field={fields[147]} clear={this.state.clear} validate={this.props.validateSkillVendorSearchField} search={this.props.onSearch}/>
                           </div>
                         </div>
                           { this.state.isRegions  &&
                            <div className="row">
                              <div className="col-11">
                                <MultiSelect field={fields[158]} clear={this.state.clear} validate={this.props.validateSkillVendorSearchField} search={this.props.onSearch}/>
                              </div>
                            </div>
                          }
                         { this.state.isEthnicity  &&
                           <div className="row">
                             <div className="col-11">
                               <MultiSelect field={fields[148]} clear={this.state.clear} validate={this.props.validateSkillVendorSearchField} search={this.props.onSearch}/>
                             </div>
                           </div>
                         }
                         { this.state.isIdentity  &&
                           <div className="row">
                             <div className="col-11">
                               <MultiSelect field={fields[149]} clear={this.state.clear} validate={this.props.validateSkillVendorSearchField} search={this.props.onSearch}/>
                             </div>
                           </div>
                         }
                         <div className="talent-search-group">
                          <label className="col-form-label">Status</label>
                            <div className="row">
                              <div className="col-11">
                                <CheckboxField clear={this.state.clear} checked={true} field={fields[12]} validate={this.props.validateSkillVendorSearchField} search={this.props.onSearch}/>
                              </div>
                            </div>
                            <div className="row">
                              <div className="col-11">
                                <CheckboxField clear={this.state.clear} field={fields[150]} validate={this.props.validateSkillVendorSearchField} search={this.props.onSearch} />
                              </div>
                            </div>
                            <div className="row">
                              <div className="col-11">
                              {/*field nr 11 before*/}
                                <CheckboxField clear={this.state.clear} field={fields[170]} validate={this.props.validateSkillVendorSearchField} search={this.props.onSearch}/>
                              </div>
                            </div>
                         </div>
                    </CardBody>
                  </Card>
                </Collapse>
            </div>
            {/*Director*/}
            <div>
              <a type="button" className="btn btn-primary btn-flat btn-icon" onClick={this.toggleDirector}>
                <i className="material-icons">{arrowIconDirector}</i>
                <span>Director {this.props.directorCounter?'(' + this.props.directorCounter + ')':''}</span>
              </a>
              <Collapse isOpen={this.state.collapseDirector} className="mb-4">
                 <Card>
                   <CardBody>
                     <div className="talent-search-group">
                      <label className="col-form-label">Status</label>
                        <div className="row">
                          <div className="col-11">
                            <CheckboxField clear={this.state.clear} field={fields[163]} validate={this.props.validateSkillVendorSearchField} search={this.props.onSearch}/>
                          </div>
                        </div>
                     </div>
                       <div className="talent-search-group">
                         <label className="col-form-label">Productions</label>
                         <div className="row">
                           <div className="col-11">
                             <CheckboxField clear={this.state.clear} field={fields[33]} validate={this.props.validateSkillVendorSearchField} search={this.props.onSearch}/>
                           </div>
                         </div>
                         <div className="row">
                           <div className="col-11">
                             <CheckboxField clear={this.state.clear} field={fields[34]} validate={this.props.validateSkillVendorSearchField} search={this.props.onSearch}/>
                           </div>
                         </div>
                         <div className="row">
                           <div className="col-11">
                             <CheckboxField clear={this.state.clear} field={fields[35]} validate={this.props.validateSkillVendorSearchField} search={this.props.onSearch}/>
                           </div>
                         </div>
                         <div className="row">
                           <div className="col-11">
                             <CheckboxField clear={this.state.clear} field={fields[36]} validate={this.props.validateSkillVendorSearchField} search={this.props.onSearch}/>
                           </div>
                         </div>
                       </div>
                       <div className="talent-search-group">
                         <label className="col-form-label">Genres</label>
                         <div className="row">
                           <div className="col-11">
                             <CheckboxField clear={this.state.clear} field={fields[37]} validate={this.props.validateSkillVendorSearchField} search={this.props.onSearch}/>
                           </div>
                         </div>
                         <div className="row">
                           <div className="col-11">
                             <CheckboxField clear={this.state.clear} field={fields[38]} validate={this.props.validateSkillVendorSearchField} search={this.props.onSearch}/>
                           </div>
                         </div>
                       </div>
                       <div className="talent-search-group">
                         <label className="col-form-label">Experience</label>
                         <div className="row">
                           <div className="col-11">
                             <CheckboxField clear={this.state.clear} field={fields[27]} validate={this.props.validateSkillVendorSearchField} search={this.props.onSearch}/>
                           </div>
                         </div>
                         <div className="row">
                           <div className="col-11">
                             <CheckboxField clear={this.state.clear} field={fields[28]} validate={this.props.validateSkillVendorSearchField} search={this.props.onSearch}/>
                           </div>
                         </div>
                         <div className="row">
                           <div className="col-11">
                             <CheckboxField clear={this.state.clear} field={fields[29]} validate={this.props.validateSkillVendorSearchField} search={this.props.onSearch}/>
                           </div>
                         </div>
                         <div className="row">
                           <div className="col-11">
                             <CheckboxField clear={this.state.clear} field={fields[30]} validate={this.props.validateSkillVendorSearchField} search={this.props.onSearch}/>
                           </div>
                         </div>
                         <div className="row">
                           <div className="col-11">
                             <CheckboxField clear={this.state.clear} field={fields[31]} validate={this.props.validateSkillVendorSearchField} search={this.props.onSearch}/>
                           </div>
                         </div>
                         <div className="row">
                           <div className="col-11">
                             <CheckboxField clear={this.state.clear} field={fields[32]} validate={this.props.validateSkillVendorSearchField} search={this.props.onSearch}/>
                           </div>
                         </div>
                         <div className="row">
                           <div className="col-11">
                             <CheckboxField clear={this.state.clear} field={fields[39]} validate={this.props.validateSkillVendorSearchField} search={this.props.onSearch}/>
                           </div>
                         </div>
                       </div>
                       <div className="row">
                        <div className="col-11">
                          <MultiSelectAutoComplete option={this.state.directorStudio} clear={this.state.clear} field={fields[133]}  getSelectedOption={this.getDirectorStudioId} search={this.props.onSearch}/>
                        </div>
                       </div>
                       <div className="row">
                        <div className="col-11">
                          <MultiSelectAutoComplete option={this.state.directorClient} clear={this.state.clear} field={fields[134]}  getSelectedOption={this.getDirectorClientId} search={this.props.onSearch}/>
                        </div>
                       </div>
                       <div className="row">
                        <div className="col-11">
                          <MultiSelectAutoComplete option={this.state.directorSchool} clear={this.state.clear} field={fields[122]}  getSelectedOption={this.getDirectorSchoolId} search={this.props.onSearch}/>
                        </div>
                       </div>
                       <div className="row">
                         <div className="col-11">
                           <ReactSelectTalentSearch clear={this.state.clear} field={fields[87]} validate={this.props.validateSkillVendorSearchField} search={this.props.onSearch}/>
                         </div>
                       </div>
                      <div className="row">
                        <div className="col-11 mt-2">
                          <ReactSelectTalentSearch clear={this.state.clear} field={fields[91]} validate={this.props.validateSkillVendorSearchField} search={this.props.onSearch}/>
                        </div>
                      </div>
                  </CardBody>
                </Card>
              </Collapse>
            </div>
            {/*Translator*/}
            <div>
              <a type="button" className="btn btn-primary btn-flat btn-icon" onClick={this.toggleTranslator}>
                <i className="material-icons">{arrowIconTranslator}</i>
                <span>Translator {this.props.translatorCounter?'(' + this.props.translatorCounter + ')':''}</span>
              </a>
              <Collapse isOpen={this.state.collapseTranslator} className="mb-4">
                 <Card>
                   <CardBody>
                   <div className="talent-search-group">
                    <label className="col-form-label">Status</label>
                      <div className="row">
                        <div className="col-11">
                          <CheckboxField clear={this.state.clear} field={fields[168]} validate={this.props.validateSkillVendorSearchField} search={this.props.onSearch}/>
                        </div>
                      </div>
                   </div>
                    <div className="talent-search-group">
                      <label className="col-form-label">Productions</label>
                      <div className="row">
                        <div className="col-11">
                          <CheckboxField clear={this.state.clear} field={fields[104]} validate={this.props.validateSkillVendorSearchField} search={this.props.onSearch}/>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-11">
                          <CheckboxField clear={this.state.clear} field={fields[105]} validate={this.props.validateSkillVendorSearchField} search={this.props.onSearch}/>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-11">
                          <CheckboxField clear={this.state.clear} field={fields[106]} validate={this.props.validateSkillVendorSearchField} search={this.props.onSearch}/>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-11">
                          <CheckboxField clear={this.state.clear} field={fields[107]} validate={this.props.validateSkillVendorSearchField} search={this.props.onSearch}/>
                        </div>
                      </div>
                    </div>
                    <div className="talent-search-group">
                      <label className="col-form-label">Genres</label>
                      <div className="row">
                        <div className="col-11">
                          <CheckboxField clear={this.state.clear} field={fields[108]} validate={this.props.validateSkillVendorSearchField} search={this.props.onSearch}/>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-11">
                          <CheckboxField clear={this.state.clear} field={fields[109]} validate={this.props.validateSkillVendorSearchField} search={this.props.onSearch}/>
                        </div>
                      </div>
                    </div>
                    <div className="talent-search-group">
                      <label className="col-form-label">Experience</label>
                      <div className="row">
                        <div className="col-11">
                          <CheckboxField clear={this.state.clear} field={fields[65]} validate={this.props.validateSkillVendorSearchField} search={this.props.onSearch}/>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-11">
                          <CheckboxField clear={this.state.clear} field={fields[66]} validate={this.props.validateSkillVendorSearchField} search={this.props.onSearch}/>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-11">
                          <CheckboxField clear={this.state.clear} field={fields[67]} validate={this.props.validateSkillVendorSearchField} search={this.props.onSearch}/>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-11">
                          <CheckboxField clear={this.state.clear} field={fields[68]} validate={this.props.validateSkillVendorSearchField} search={this.props.onSearch}/>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-11">
                          <CheckboxField clear={this.state.clear} field={fields[69]} validate={this.props.validateSkillVendorSearchField} search={this.props.onSearch}/>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-11">
                          <CheckboxField clear={this.state.clear} field={fields[70]} validate={this.props.validateSkillVendorSearchField} search={this.props.onSearch}/>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-11">
                        <MultiSelect field={fields[86]} clear={this.state.clear} validate={this.props.validateSkillVendorSearchField} search={this.props.onSearch}/>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-11">
                        <MultiSelect field={fields[116]} clear={this.state.clear} validate={this.props.validateSkillVendorSearchField} search={this.props.onSearch}/>
                      </div>
                    </div>
                    <div className="row">
                     <div className="col-11">
                       <MultiSelectAutoComplete option={this.state.translatorStudios} clear={this.state.clear} field={fields[143]}  getSelectedOption={this.getTranslatorStudioId} search={this.props.onSearch}/>
                     </div>
                     </div>
                     <div className="row">
                      <div className="col-11">
                        <MultiSelectAutoComplete option={this.state.translatorClients} clear={this.state.clear} field={fields[144]}  getSelectedOption={this.getTranslatorClientId} search={this.props.onSearch}/>
                      </div>
                     </div>
                  </CardBody>
                </Card>
              </Collapse>
            </div>
            {/*Adaptor*/}
            <div>
              <a type="button" className="btn btn-primary btn-flat btn-icon" onClick={this.toggleAdaptor}>
                <i className="material-icons">{arrowIconAdaptor}</i>
                <span>Adaptor {this.props.adaptorCounter?'(' + this.props.adaptorCounter + ')':''}</span>
              </a>
              <Collapse isOpen={this.state.collapseAdaptor} className="mb-4">
                 <Card>
                   <CardBody>
                     <div className="talent-search-group">
                      <label className="col-form-label">Status</label>
                        <div className="row">
                          <div className="col-11">
                            <CheckboxField clear={this.state.clear} field={fields[161]} validate={this.props.validateSkillVendorSearchField} search={this.props.onSearch}/>
                          </div>
                        </div>
                     </div>
                       <div className="talent-search-group">
                         <label className="col-form-label">Productions</label>
                         <div className="row">
                           <div className="col-11">
                             <CheckboxField clear={this.state.clear} field={fields[17]} validate={this.props.validateSkillVendorSearchField} search={this.props.onSearch}/>
                           </div>
                         </div>
                         <div className="row">
                           <div className="col-11">
                             <CheckboxField clear={this.state.clear} field={fields[18]} validate={this.props.validateSkillVendorSearchField} search={this.props.onSearch}/>
                           </div>
                         </div>
                         <div className="row">
                           <div className="col-11">
                             <CheckboxField clear={this.state.clear} field={fields[19]} validate={this.props.validateSkillVendorSearchField} search={this.props.onSearch}/>
                           </div>
                         </div>
                         <div className="row">
                           <div className="col-11">
                             <CheckboxField clear={this.state.clear} field={fields[20]} validate={this.props.validateSkillVendorSearchField} search={this.props.onSearch}/>
                           </div>
                         </div>
                       </div>
                       <div className="talent-search-group">
                         <label className="col-form-label">Genres</label>
                         <div className="row">
                           <div className="col-11">
                             <CheckboxField clear={this.state.clear} field={fields[21]} validate={this.props.validateSkillVendorSearchField} search={this.props.onSearch}/>
                           </div>
                         </div>
                         <div className="row">
                           <div className="col-11">
                             <CheckboxField clear={this.state.clear} field={fields[22]} validate={this.props.validateSkillVendorSearchField} search={this.props.onSearch}/>
                           </div>
                         </div>
                       </div>
                       <div className="talent-search-group">
                         <label className="col-form-label">Experience</label>
                         <div className="row">
                           <div className="col-11">
                             <CheckboxField clear={this.state.clear} clear={this.state.clear} field={fields[13]} validate={this.props.validateSkillVendorSearchField} search={this.props.onSearch}/>
                           </div>
                         </div>
                         <div className="row">
                           <div className="col-11">
                             <CheckboxField clear={this.state.clear} clear={this.state.clear} field={fields[14]} validate={this.props.validateSkillVendorSearchField} search={this.props.onSearch}/>
                           </div>
                         </div>
                         <div className="row">
                           <div className="col-11">
                             <CheckboxField clear={this.state.clear} field={fields[15]} validate={this.props.validateSkillVendorSearchField} search={this.props.onSearch}/>
                           </div>
                         </div>
                         <div className="row">
                           <div className="col-11">
                             <CheckboxField clear={this.state.clear} field={fields[16]} validate={this.props.validateSkillVendorSearchField} search={this.props.onSearch}/>
                           </div>
                         </div>
                         <div className="row">
                           <div className="col-11">
                             <CheckboxField clear={this.state.clear} field={fields[23]} validate={this.props.validateSkillVendorSearchField} search={this.props.onSearch}/>
                           </div>
                         </div>
                       </div>
                       <div className="row">
                        <div className="col-11">
                          <MultiSelect field={fields[84]} clear={this.state.clear} validate={this.props.validateSkillVendorSearchField} search={this.props.onSearch}/>
                        </div>
                       </div>
                       <div className="row">
                         <div className="col-11">
                           <MultiSelect field={fields[114]} clear={this.state.clear} validate={this.props.validateSkillVendorSearchField} search={this.props.onSearch}/>
                         </div>
                       </div>
                       <div className="row">
                        <div className="col-11">
                          <MultiSelectAutoComplete option={this.state.adaptorStudios} clear={this.state.clear} field={fields[129]} getSelectedOption={this.getAdaptorStudioId} search={this.props.onSearch}/>
                        </div>
                       </div>
                       <div className="row">
                        <div className="col-11">
                          <MultiSelectAutoComplete option={this.state.adaptorClients} clear={this.state.clear} field={fields[130]}  getSelectedOption={this.getAdaptorClientId} search={this.props.onSearch}/>
                        </div>
                       </div>
                  </CardBody>
                </Card>
              </Collapse>
            </div>
            {/*Lyricist*/}
            <div>
              <a type="button" className="btn btn-primary btn-flat btn-icon" onClick={this.toggleLyricist}>
                <i className="material-icons">{arrowIconLyricist}</i>
                <span>Lyricist {this.props.lyricistCounter?'(' + this.props.lyricistCounter + ')':''}</span>
              </a>
              <Collapse isOpen={this.state.collapseLyricist} className="mb-4">
                 <Card>
                   <CardBody>
                   <div className="talent-search-group">
                    <label className="col-form-label">Status</label>
                      <div className="row">
                        <div className="col-11">
                          <CheckboxField clear={this.state.clear} field={fields[165]} validate={this.props.validateSkillVendorSearchField} search={this.props.onSearch}/>
                        </div>
                      </div>
                   </div>
                    <div className="talent-search-group">
                      <label className="col-form-label">Productions</label>
                      <div className="row">
                        <div className="col-11">
                          <CheckboxField clear={this.state.clear} clear={this.state.clear} field={fields[92]} validate={this.props.validateSkillVendorSearchField} search={this.props.onSearch}/>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-11">
                          <CheckboxField clear={this.state.clear} clear={this.state.clear} field={fields[93]} validate={this.props.validateSkillVendorSearchField} search={this.props.onSearch}/>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-11">
                          <CheckboxField clear={this.state.clear} field={fields[94]} validate={this.props.validateSkillVendorSearchField} search={this.props.onSearch}/>
                        </div>
                      </div>
                    </div>
                    <div className="talent-search-group">
                      <label className="col-form-label">Experience</label>
                      <div className="row">
                        <div className="col-11">
                          <CheckboxField clear={this.state.clear} field={fields[53]} validate={this.props.validateSkillVendorSearchField} search={this.props.onSearch}/>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-11">
                          <CheckboxField clear={this.state.clear} field={fields[54]} validate={this.props.validateSkillVendorSearchField} search={this.props.onSearch}/>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-11">
                          <CheckboxField clear={this.state.clear} field={fields[55]} validate={this.props.validateSkillVendorSearchField} search={this.props.onSearch}/>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-11">
                        <MultiSelect clear={this.state.clear} field={fields[85]} clear={this.state.clear} validate={this.props.validateSkillVendorSearchField} search={this.props.onSearch}/>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-11">
                        <MultiSelect clear={this.state.clear} field={fields[115]} clear={this.state.clear} validate={this.props.validateSkillVendorSearchField} search={this.props.onSearch}/>
                      </div>
                    </div>
                    <div className="row">
                     <div className="col-11">
                       <MultiSelectAutoComplete option={this.state.lyricistStudio} clear={this.state.clear} field={fields[137]}  getSelectedOption={this.getLyricistStudioId} search={this.props.onSearch}/>
                     </div>
                     </div>
                     <div className="row">
                      <div className="col-11">
                        <MultiSelectAutoComplete option={this.state.lyricistClient} clear={this.state.clear} field={fields[138]}  getSelectedOption={this.getLyricistClientId} search={this.props.onSearch}/>
                      </div>
                     </div>
                    <div className="row">
                      <div className="col-11">
                        <ReactSelectTalentSearch clear={this.state.clear} field={fields[88]} validate={this.props.validateSkillVendorSearchField} search={this.props.onSearch}/>
                      </div>
                    </div>
                  </CardBody>
                </Card>
              </Collapse>
            </div>
            {/*VoiceActor*/}
            <div>
              <a type="button" className="btn btn-primary btn-flat btn-icon" onClick={this.toggleVoiceActor}>
                <i className="material-icons">{arrowIconVoiceActor}</i>
                <span>Actor {this.props.actorCounter?'(' + this.props.actorCounter + ')':''}</span>
              </a>
              <Collapse isOpen={this.state.collapseVoiceActor} className="mb-4">
                 <Card>
                   <CardBody>
                   <div className="talent-search-group">
                    <label className="col-form-label">Status</label>
                      <div className="row">
                        <div className="col-11">
                          <CheckboxField clear={this.state.clear} field={fields[169]} validate={this.props.validateSkillVendorSearchField} search={this.props.onSearch}/>
                        </div>
                      </div>
                   </div>
                    <div className="talent-search-group">
                      <label className="col-form-label">Voice gender (L/A)</label>
                      <div className="row">
                        <div className="col-11">
                          <CheckboxField clear={this.state.clear} field={fields[110]} validate={this.props.validateSkillVendorSearchField} search={this.props.onSearch}/>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-11">
                          <CheckboxField clear={this.state.clear} field={fields[111]} validate={this.props.validateSkillVendorSearchField} search={this.props.onSearch}/>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-11">
                          <CheckboxField clear={this.state.clear} field={fields[160]} validate={this.props.validateSkillVendorSearchField} search={this.props.onSearch}/>
                        </div>
                      </div>
                    </div>
                    <div className="talent-search-group">
                      <label className="col-form-label">Voice gender (Animation)</label>
                      <div className="row">
                        <div className="col-11">
                          <CheckboxField clear={this.state.clear} field={fields[112]} validate={this.props.validateSkillVendorSearchField} search={this.props.onSearch}/>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-11">
                          <CheckboxField clear={this.state.clear} field={fields[113]} validate={this.props.validateSkillVendorSearchField} search={this.props.onSearch}/>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-11">
                          <CheckboxField clear={this.state.clear} field={fields[160]} validate={this.props.validateSkillVendorSearchField} search={this.props.onSearch}/>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-11">
                        <MultiSelect field={fields[151]} clear={this.state.clear} validate={this.props.validateSkillVendorSearchField} search={this.props.onSearch}/>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-11">
                        <MultiSelect field={fields[152]} clear={this.state.clear} validate={this.props.validateSkillVendorSearchField} search={this.props.onSearch}/>
                      </div>
                    </div>
                    { this.state.isAccent &&
                      <div className="row">
                        <div className="col-11">
                          <MultiSelect field={fields[153]} clear={this.state.clear} validate={this.props.validateSkillVendorSearchField} search={this.props.onSearch}/>
                        </div>
                      </div>
                    }
                    <div className="talent-search-group">
                      <label className="col-form-label">Productions</label>
                      <div className="row">
                        <div className="col-11">
                          <CheckboxField clear={this.state.clear} field={fields[78]} validate={this.props.validateSkillVendorSearchField} search={this.props.onSearch}/>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-11">
                          <CheckboxField clear={this.state.clear} field={fields[79]} validate={this.props.validateSkillVendorSearchField} search={this.props.onSearch}/>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-11">
                          <CheckboxField clear={this.state.clear} field={fields[80]} validate={this.props.validateSkillVendorSearchField} search={this.props.onSearch}/>
                        </div>
                      </div>
                      <div className="row">
                      <div className="col-11">
                        <CheckboxField clear={this.state.clear} field={fields[81]} validate={this.props.validateSkillVendorSearchField} search={this.props.onSearch}/>
                      </div>
                    </div>
                  </div>
                  <div className="talent-search-group">
                    <label className="col-form-label">Genres</label>
                    <div className="row">
                      <div className="col-11">
                        <CheckboxField clear={this.state.clear} field={fields[82]} validate={this.props.validateSkillVendorSearchField} search={this.props.onSearch}/>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-11">
                        <CheckboxField clear={this.state.clear} field={fields[83]} validate={this.props.validateSkillVendorSearchField} search={this.props.onSearch}/>
                      </div>
                    </div>
                  </div>
                  <div className="talent-search-group">
                    <label className="col-form-label">Experience</label>
                    <div className="row">
                      <div className="col-11">
                        <CheckboxField clear={this.state.clear} field={fields[71]} validate={this.props.validateSkillVendorSearchField} search={this.props.onSearch}/>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-11">
                        <CheckboxField clear={this.state.clear} field={fields[72]} validate={this.props.validateSkillVendorSearchField} search={this.props.onSearch}/>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-11">
                        <CheckboxField clear={this.state.clear} field={fields[73]} validate={this.props.validateSkillVendorSearchField} search={this.props.onSearch}/>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-11">
                        <CheckboxField clear={this.state.clear} clear={this.state.clear} field={fields[74]} validate={this.props.validateSkillVendorSearchField} search={this.props.onSearch}/>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-11">
                        <CheckboxField clear={this.state.clear} clear={this.state.clear} field={fields[75]} validate={this.props.validateSkillVendorSearchField} search={this.props.onSearch}/>
                      </div>
                   </div>
                   <div className="row">
                     <div className="col-11">
                       <CheckboxField clear={this.state.clear} field={fields[76]} validate={this.props.validateSkillVendorSearchField} search={this.props.onSearch}/>
                     </div>
                    </div>
                    <div className="row">
                      <div className="col-11">
                        <CheckboxField clear={this.state.clear} field={fields[77]} validate={this.props.validateSkillVendorSearchField} search={this.props.onSearch}/>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                   <div className="col-11">
                     <MultiSelectAutoComplete option={this.state.voiceActorStudio} clear={this.state.clear} field={fields[145]} getSelectedOption={this.getVoiceActorStudioId} search={this.props.onSearch}/>
                   </div>
                   </div>
                   <div className="row">
                    <div className="col-11">
                      <MultiSelectAutoComplete option={this.state.voiceActorClient} clear={this.state.clear} field={fields[146]}  getSelectedOption={this.getVoiceActorClientId} search={this.props.onSearch}/>
                    </div>
                   </div>
                    <div className="row">
                     <div className="col-11">
                       <MultiSelectAutoComplete option={this.state.voiceActorSchool} clear={this.state.clear} field={fields[128]}  getSelectedOption={this.getVoiceActorSchoolId} search={this.props.onSearch}/>
                     </div>
                    </div>
                   { this.state.isUnion &&
                     <div className="row">
                       <div className="col-11">
                         <MultiSelect clear={this.state.clear}  field={fields[154]} validate={this.props.validateSkillVendorSearchField} search={this.props.onSearch}/>
                       </div>
                     </div>
                   }
                   <div className="row">
                     <div className="col-11">
                       <ReactSelectTalentSearch clear={this.state.clear} field={fields[90]} validate={this.props.validateSkillVendorSearchField} search={this.props.onSearch}/>
                     </div>
                   </div>
                  </CardBody>
                </Card>
              </Collapse>
            </div>
            {/*Singer*/}
            <div>
              <a type="button" className="btn btn-primary btn-flat btn-icon" onClick={this.toggleSinger}>
                <i className="material-icons">{arrowIconSinger}</i>
                <span>Singer {this.props.singerCounter?'(' + this.props.singerCounter + ')':''}</span>
              </a>
              <Collapse isOpen={this.state.collapseSinger} className="mb-4">
                 <Card>
                   <CardBody>
                   <div className="talent-search-group">
                    <label className="col-form-label">Status</label>
                      <div className="row">
                        <div className="col-11">
                          <CheckboxField clear={this.state.clear} field={fields[166]} validate={this.props.validateSkillVendorSearchField} search={this.props.onSearch}/>
                        </div>
                      </div>
                   </div>
                     <div className="talent-search-group">
                     <label className="col-form-label">Voice gender</label>
                     <div className="row">
                       <div className="col-11">
                         <CheckboxField clear={this.state.clear} clear={this.state.clear} field={fields[95]} validate={this.props.validateSkillVendorSearchField} search={this.props.onSearch}/>
                       </div>
                     </div>
                     <div className="row">
                       <div className="col-11">
                         <CheckboxField  clear={this.state.clear} field={fields[96]} validate={this.props.validateSkillVendorSearchField} search={this.props.onSearch}/>
                       </div>
                     </div>
                     <div className="row">
                       <div className="col-11">
                         <CheckboxField clear={this.state.clear} field={fields[159]} validate={this.props.validateSkillVendorSearchField} search={this.props.onSearch}/>
                       </div>
                     </div>
                     </div>
                     <div className="row">
                       <div className="col-11">
                         <MultiSelect field={fields[119]} clear={this.state.clear} validate={this.props.validateSkillVendorSearchField} search={this.props.onSearch}/>
                       </div>
                     </div>
                     <div className="row">
                       <div className="col-11">
                         <MultiSelect field={fields[117]} clear={this.state.clear} validate={this.props.validateSkillVendorSearchField} search={this.props.onSearch}/>
                       </div>
                     </div>
                     <div className="row">
                       <div className="col-11">
                         <MultiSelect field={fields[118]} clear={this.state.clear} validate={this.props.validateSkillVendorSearchField} search={this.props.onSearch}/>
                       </div>
                     </div>
                     <div className="talent-search-group">
                      <label className="col-form-label">Experience</label>
                      <div className="row">
                        <div className="col-11">
                          <CheckboxField clear={this.state.clear} field={fields[56]} validate={this.props.validateSkillVendorSearchField} search={this.props.onSearch}/>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-11">
                          <CheckboxField clear={this.state.clear} field={fields[57]} validate={this.props.validateSkillVendorSearchField} search={this.props.onSearch}/>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-11">
                          <CheckboxField clear={this.state.clear} field={fields[58]} validate={this.props.validateSkillVendorSearchField} search={this.props.onSearch}/>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-11">
                          <CheckboxField clear={this.state.clear} field={fields[59]} validate={this.props.validateSkillVendorSearchField} search={this.props.onSearch}/>
                        </div>
                      </div>
                     </div>
                     <div className="row">
                      <div className="col-11">
                        <MultiSelectAutoComplete option={this.state.singerStudio} clear={this.state.clear} field={fields[139]}  getSelectedOption={this.getSingerStudioId} search={this.props.onSearch}/>
                      </div>
                     </div>
                     <div className="row">
                      <div className="col-11">
                        <MultiSelectAutoComplete option={this.state.singerClient} clear={this.state.clear} field={fields[140]}  getSelectedOption={this.getSingerClientId} search={this.props.onSearch}/>
                      </div>
                     </div>
                     <div className="row">
                      <div className="col-11">
                        <MultiSelectAutoComplete option={this.state.singerSchool} clear={this.state.clear} field={fields[125]}  getSelectedOption={this.getSingerSchoolId} search={this.props.onSearch}/>
                      </div>
                     </div>
                     { this.state.isUnion &&
                       <div className="row">
                         <div className="col-11">
                           <MultiSelect field={fields[156]} clear={this.state.clear} validate={this.props.validateSkillVendorSearchField} search={this.props.onSearch}/>
                         </div>
                       </div>
                     }
                      <div className="row">
                        <div className="col-11">
                          <ReactSelectTalentSearch clear={this.state.clear} field={fields[155]} validate={this.props.validateSkillVendorSearchField} search={this.props.onSearch} />
                        </div>
                      </div>
                  </CardBody>
                </Card>
              </Collapse>
            </div>
            {/*Editor*/}
            <div>
              <a type="button" className="btn btn-primary btn-flat btn-icon" onClick={this.toggleEditor}>
                <i className="material-icons">{arrowIconEditor}</i>
                <span>Dialogue editor {this.props.editorCounter?'(' + this.props.editorCounter + ')':''}</span>
              </a>
              <Collapse isOpen={this.state.collapseEditor} className="mb-4">
                 <Card>
                   <CardBody>
                   <div className="talent-search-group">
                    <label className="col-form-label">Status</label>
                      <div className="row">
                        <div className="col-11">
                          <CheckboxField clear={this.state.clear} field={fields[164]} validate={this.props.validateSkillVendorSearchField} search={this.props.onSearch}/>
                        </div>
                      </div>
                   </div>
                     <div className="talent-search-group">
                       <label className="col-form-label">Productions</label>
                       <div className="row">
                         <div className="col-11">
                           <CheckboxField clear={this.state.clear} field={fields[45]} validate={this.props.validateSkillVendorSearchField} search={this.props.onSearch}/>
                         </div>
                       </div>
                       <div className="row">
                         <div className="col-11">
                           <CheckboxField clear={this.state.clear} field={fields[46]} validate={this.props.validateSkillVendorSearchField} search={this.props.onSearch}/>
                         </div>
                       </div>
                       <div className="row">
                         <div className="col-11">
                           <CheckboxField clear={this.state.clear} field={fields[47]} validate={this.props.validateSkillVendorSearchField} search={this.props.onSearch}/>
                         </div>
                       </div>
                     </div>
                     <div className="talent-search-group">
                       <label className="col-form-label">Skills</label>
                       <div className="row">
                         <div className="col-11">
                           <CheckboxField clear={this.state.clear} field={fields[48]} validate={this.props.validateSkillVendorSearchField} search={this.props.onSearch}/>
                         </div>
                       </div>
                       <div className="row">
                         <div className="col-11">
                           <CheckboxField clear={this.state.clear} field={fields[49]} validate={this.props.validateSkillVendorSearchField} search={this.props.onSearch}/>
                         </div>
                       </div>
                       <div className="row">
                         <div className="col-11">
                           <CheckboxField clear={this.state.clear} field={fields[50]} validate={this.props.validateSkillVendorSearchField} search={this.props.onSearch}/>
                         </div>
                       </div>
                       <div className="row">
                         <div className="col-11">
                           <CheckboxField clear={this.state.clear} field={fields[51]} validate={this.props.validateSkillVendorSearchField} search={this.props.onSearch}/>
                         </div>
                       </div>
                     </div>
                     <div className="talent-search-group">
                      <label className="col-form-label">Experience</label>
                      <div className="row">
                        <div className="col-11">
                          <CheckboxField clear={this.state.clear} field={fields[40]} validate={this.props.validateSkillVendorSearchField} search={this.props.onSearch}/>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-11">
                          <CheckboxField clear={this.state.clear} field={fields[41]} validate={this.props.validateSkillVendorSearchField} search={this.props.onSearch}/>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-11">
                          <CheckboxField clear={this.state.clear} field={fields[42]} validate={this.props.validateSkillVendorSearchField} search={this.props.onSearch}/>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-11">
                          <CheckboxField clear={this.state.clear} field={fields[43]} validate={this.props.validateSkillVendorSearchField} search={this.props.onSearch}/>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-11">
                          <CheckboxField clear={this.state.clear} field={fields[44]} validate={this.props.validateSkillVendorSearchField} search={this.props.onSearch}/>
                        </div>
                      </div>
                      <div className="row">
                      <div className="col-11">
                        <CheckboxField clear={this.state.clear} field={fields[52]} validate={this.props.validateSkillVendorSearchField} search={this.props.onSearch}/>
                      </div>
                      </div>
                     </div>
                     <div className="row">
                      <div className="col-11">
                        <MultiSelectAutoComplete option={this.state.editorStudios} clear={this.state.clear} field={fields[135]}  getSelectedOption={this.getEditorStudioId} search={this.props.onSearch}/>
                      </div>
                    </div>
                     <div className="row">
                      <div className="col-11">
                        <MultiSelectAutoComplete option={this.state.editorClients} clear={this.state.clear} field={fields[136]}  getSelectedOption={this.getEditorClientId} search={this.props.onSearch}/>
                      </div>
                     </div>
                     <div className="row">
                      <div className="col-11">
                        <MultiSelectAutoComplete option={this.state.editorSchools} clear={this.state.clear} field={fields[123]}  getSelectedOption={this.getEditorSchoolId} search={this.props.onSearch}/>
                      </div>
                     </div>
                     <div className="row">
                       <div className="col-11">
                         <ReactSelectTalentSearch clear={this.state.clear} field={fields[157]} validate={this.props.validateSkillVendorSearchField} search={this.props.onSearch}/>
                       </div>
                     </div>
                  </CardBody>
                </Card>
              </Collapse>
            </div>
            {/*SoundEngineer*/}
            <div>
              <a type="button" className="btn btn-primary btn-flat btn-icon" onClick={this.toggleSoundEngineer}>
                <i className="material-icons">{arrowIconSoundEngineer}</i>
                <span>Sound Engineer {this.props.soundEngineerCounter?'(' + this.props.soundEngineerCounter + ')':''}</span>
              </a>
              <Collapse isOpen={this.state.collapseSoundEngineer} className="mb-4">
                 <Card>
                   <CardBody>
                   <div className="talent-search-group">
                    <label className="col-form-label">Status</label>
                      <div className="row">
                        <div className="col-11">
                          <CheckboxField clear={this.state.clear} field={fields[167]} validate={this.props.validateSkillVendorSearchField} search={this.props.onSearch}/>
                        </div>
                      </div>
                   </div>
                     <div className="talent-search-group">
                      <label className="col-form-label">Productions</label>
                      <div className="row">
                        <div className="col-11">
                          <CheckboxField clear={this.state.clear} field={fields[97]} validate={this.props.validateSkillVendorSearchField} search={this.props.onSearch}/>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-11">
                          <CheckboxField clear={this.state.clear} field={fields[98]} validate={this.props.validateSkillVendorSearchField} search={this.props.onSearch}/>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-11">
                          <CheckboxField clear={this.state.clear} field={fields[99]} validate={this.props.validateSkillVendorSearchField} search={this.props.onSearch}/>
                        </div>
                      </div>
                     </div>
                     <div className="talent-search-group">
                      <label className="col-form-label">Skills</label>
                      <div className="row">
                        <div className="col-11">
                          <CheckboxField clear={this.state.clear} field={fields[100]} validate={this.props.validateSkillVendorSearchField} search={this.props.onSearch}/>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-11">
                          <CheckboxField clear={this.state.clear} field={fields[101]} validate={this.props.validateSkillVendorSearchField} search={this.props.onSearch}/>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-11">
                          <CheckboxField clear={this.state.clear} field={fields[102]} validate={this.props.validateSkillVendorSearchField} search={this.props.onSearch}/>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-11">
                          <CheckboxField clear={this.state.clear} field={fields[103]} validate={this.props.validateSkillVendorSearchField} search={this.props.onSearch}/>
                        </div>
                      </div>
                     </div>
                     <div className="talent-search-group">
                     <label className="col-form-label">Experience</label>
                     <div className="row">
                       <div className="col-11">
                         <CheckboxField clear={this.state.clear} field={fields[60]} validate={this.props.validateSkillVendorSearchField} search={this.props.onSearch}/>
                       </div>
                     </div>
                     <div className="row">
                       <div className="col-11">
                         <CheckboxField clear={this.state.clear} field={fields[61]} validate={this.props.validateSkillVendorSearchField} search={this.props.onSearch}/>
                       </div>
                     </div>
                     <div className="row">
                       <div className="col-11">
                         <CheckboxField clear={this.state.clear} field={fields[62]} validate={this.props.validateSkillVendorSearchField} search={this.props.onSearch}/>
                       </div>
                     </div>
                     <div className="row">
                       <div className="col-11">
                         <CheckboxField clear={this.state.clear} field={fields[63]} validate={this.props.validateSkillVendorSearchField} search={this.props.onSearch}/>
                       </div>
                     </div>
                     <div className="row">
                       <div className="col-11">
                         <CheckboxField clear={this.state.clear} field={fields[64]} validate={this.props.validateSkillVendorSearchField} search={this.props.onSearch}/>
                       </div>
                     </div>
                     </div>
                     <div className="row">
                      <div className="col-11">
                        <MultiSelectAutoComplete option={this.state.soundEngineerStudios} clear={this.state.clear} field={fields[141]}  getSelectedOption={this.getSoundEngineerStudioId} search={this.props.onSearch}/>
                      </div>
                     </div>
                     <div className="row">
                      <div className="col-11">
                        <MultiSelectAutoComplete option={this.state.soundEngineerClients} clear={this.state.clear} field={fields[142]}  getSelectedOption={this.getSoundEngineerClientId} search={this.props.onSearch}/>
                      </div>
                     </div>
                     <div className="row">
                      <div className="col-11">
                        <MultiSelectAutoComplete option={this.state.soundEngineerSchools} clear={this.state.clear} field={fields[126]}  getSelectedOption={this.getSoundEngineerSchoolId} search={this.props.onSearch}/>
                      </div>
                     </div>
                     <div className="row">
                       <div className="col-11">
                         <ReactSelectTalentSearch clear={this.state.clear} field={fields[89]} validate={this.props.validateSkillVendorSearchField} search={this.props.onSearch}/>
                       </div>
                     </div>
                  </CardBody>
                </Card>
              </Collapse>
            </div>
            {/*Booker*/}
            <div>
              <a type="button" className="btn btn-primary btn-flat btn-icon" onClick={this.toggleBooker}>
                <i className="material-icons">{arrowIconBooker}</i>
                <span>Booker {this.props.bookerCounter?'(' + this.props.bookerCounter + ')':''}</span>
              </a>
              <Collapse isOpen={this.state.collapseBooker} className="mb-4">
                 <Card>
                   <CardBody>
                   <div className="talent-search-group">
                    <label className="col-form-label">Status</label>
                      <div className="row">
                        <div className="col-11">
                          <CheckboxField clear={this.state.clear} field={fields[162]} validate={this.props.validateSkillVendorSearchField} search={this.props.onSearch}/>
                        </div>
                      </div>
                   </div>
                     <div className="talent-search-group">
                      <label className="col-form-label">Experience</label>
                      <div className="row">
                        <div className="col-11">
                          <CheckboxField clear={this.state.clear} field={fields[24]} validate={this.props.validateSkillVendorSearchField} search={this.props.onSearch}/>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-11">
                          <CheckboxField clear={this.state.clear} field={fields[25]} validate={this.props.validateSkillVendorSearchField} search={this.props.onSearch}/>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-11">
                          <CheckboxField clear={this.state.clear} field={fields[26]} validate={this.props.validateSkillVendorSearchField} search={this.props.onSearch}/>
                        </div>
                      </div>
                     </div>
                     <div className="row">
                      <div className="col-11">
                        <MultiSelectAutoComplete option={this.state.bookerStudio} clear={this.state.clear} field={fields[131]} getSelectedOption={this.getBookerStudioId} search={this.props.onSearch}/>
                      </div>
                     </div>
                  </CardBody>
                </Card>
              </Collapse>
            </div>
            <div>
              <a type="button" className="btn btn-primary btn-flat btn-icon" onClick={this.toggleProductions}>
                <i className="material-icons">{arrowIconProductions}</i>
                <span>Cast {this.props.castCounter?'(' + this.props.castCounter + ')':''}</span>
              </a>
              <Collapse isOpen={this.state.collapseProductions} className="mb-4">
                 <Card>
                   <CardBody>
                      <div className="row">
                        <div className="col-11">
                          <MultiSelectAutoComplete option={this.state.productionCast} clear={this.state.clear} field={fields[8]}  getSelectedOption={this.getProductionId} search={this.props.onSearch}/>
                        </div>
                      </div>
                      <div className="row">
                       <div className="col-11">
                         <MultiSelectAutoComplete option={this.state.vacancyCast} clear={this.state.clear} field={fields[9]}  getSelectedOption={this.getVacancyId} search={this.props.onSearch}/>
                       </div>
                      </div>
                      <div className="row">
                        <div className="col-11">
                          <MultiSelectAutoComplete option={this.state.externalExperienceCast} clear={this.state.clear} field={fields[10]}  getSelectedOption={this.getExternalExperienceId} search={this.props.onSearch}/>
                        </div>
                      </div>
                  </CardBody>
                </Card>
              </Collapse>
            </div>
        </div>
      </SingleLineSearchForm>
    )
  }
}

const mapStateToProps = (state) => ({
  fields: state.skillVendorSearch.fields
})
const mapDispatchToProps = dispatch => ({
  validateSkillVendorSearchField(value, field) { dispatch(validateSkillVendorSearchField(value, field)) },
  setSkillVendorSearchDropdownOptions(skillTypes, skillLevels, ageFromList, ageToList, city,school, nativeLanguage, experience, remoteRecordingCapability, gender, skillVendorStatus, numberOfAdaptionsRange, numberOfSongsWrittenRange, numberOfTranslationsRange, lyricistRemoteRecordingCapability, soundEngineerRemoteRecordingCapability, directorRemoteRecordingCapability, voiceActorRemoteRecordingCapability, universityDegreeList, vocalRangeList, musicNotesReadingLevelList, voiceAgeRangeList, countryList, ethnicityList, identityList, voiceType, languageAccentList, unionList, regionList, remoteRecordingDirector, remoteRecordingListLyricist,
  remoteRecordingListVoiceActor,remoteRecordingListSinger,remoteRecordingEditor,remoteRecordingListSoundEngineer, universityDegreeListAdaptor,
universityDegreeListLyricist, voiceAgeRangeListSinger, unionListSinger, directorAppAccess) { dispatch(setSkillVendorSearchDropdownOptions(skillTypes, skillLevels, ageFromList, ageToList, city,school, nativeLanguage, experience, remoteRecordingCapability, gender, skillVendorStatus, numberOfAdaptionsRange, numberOfSongsWrittenRange, numberOfTranslationsRange, lyricistRemoteRecordingCapability, soundEngineerRemoteRecordingCapability, directorRemoteRecordingCapability, voiceActorRemoteRecordingCapability, universityDegreeList, vocalRangeList, musicNotesReadingLevelList, voiceAgeRangeList, countryList,
    ethnicityList, identityList, voiceType, languageAccentList, unionList, regionList, remoteRecordingDirector, remoteRecordingListLyricist,
    remoteRecordingListVoiceActor,remoteRecordingListSinger,remoteRecordingEditor,remoteRecordingListSoundEngineer, universityDegreeListAdaptor,
  universityDegreeListLyricist, voiceAgeRangeListSinger, unionListSinger, directorAppAccess)) },
  setSkillVendorSearchCheckboxValue(knownTalent, doNotUse, skillVendorStatus, liveActionVoiceGenderMale, liveActionVoiceGenderFemale, voiceActorTheatricalExperience,
  voiceActorTVExperience, voiceActorVideoGamesExperience,voiceActorPromoOrCommercialsExperience, voiceActorAnimationMaleVoiceGender,voiceActorAnimationFemaleVoiceGender,
voiceActorLiveActionExperience, voiceActorAnimationExperience,voiceActorDubbingExperience,voiceActorAudiobooksExperience, voiceActorVoiceOverExperience,
voiceActorRadioExperience,voiceActorTheatreActorExperience,voiceActorMovieActorExperience,voiceActorAudioDescriptionExperience, bookerTheatricalExperience,
bookerTVExperience, bookerInteractiveExperience, singerMaleVoiceGender, singerFemaleVoiceGender, singerDubbingExperience,singerStageExperience,singerTheatreExperience,
singerTalentShowExperience, directorTheatricalExperience, directorTVExperience, directorGamesExperience, directorPromoOrCommercialsExperience,
directorLiveActionExperience, directorAnimationExperience, directorDubbingDirectorExperience, directorVoiceOverDirectorExperience, directorSongDirectorExperience,
directorDubbingActorExperience, directorStageDirectorExperience, directorMovieDirectorExperience, directorAudioDescriptionExperience, lyricistMusicalExperience,
lyricistTheatreExperience, lyricistPromoCommercialsExperience, lyricistExperience, lyricistDubbingExperience, lyricistMusicianExperience,
translatorTheatricalExperience, translatorTVExperience, translatorGamesExperience, translatorPromoOrCommercialsExperience, translatorLiveActionExperience,
translatorAnimationExperience, translatorSubtitlesExperience, translatorDubbingExperience, translatorVoiceOverExperience, translatorGamingExperience,
translatorAudioDescriptionExperience,translatorHOHSDHCCExperience, editorDubbingExperience, editorVoiceOverExperience, editorSongsExperience, editorProToolsExperience,
editorDolby51Experience, editorAtmosExperience, editorFoleyExperience, editorRecordingEditingExperience, editorDialogueEditingExperience, editorMusicAndEffectsExperience,
editorMixEditingExperience, editorPreparingTakesExperience, editorAudioDescriptionExperience, adaptorTheatricalExperience,adaptorTVExperience, adaptorGamesExperience,
adaptorPromoOrCommercialsExperience, adaptorLiveActionExperience, adaptorAnimationExperience, adaptorAdaptorExperience, adaptorDubbingDirectorExperience,
adaptorTranslatorExperience, adaptorVoiceActorExperience, adaptorAudioDescriptionExperience, soundEngineerDubbingExperience, soundEngineerVoiceOverExperience,
soundEngineerSongsExperience, soundEngineerProToolsExperience,soundEngineerDolby51Experience,soundEngineerAtmosExperience,soundEngineerFoleyExperience,
soundEngineerDialogueRecordingExperience,soundEngineerSongRecordingExperience,soundEngineerDialogueMixingExperience,soundEngineerSongMixingExperience,
soundEngineerAudioDescriptionMixingExperience,singerGenderNeutralVoice, voiceActorGenderNeutralVoice,  adaptorDoNotUse, bookerDoNotUse, directorDoNotUse, editorDoNotUse, lyricistDoNotUse, singerDoNotUse,
soundEngineerDoNotUse, translatorDoNotUse, voiceActorDoNotUse, skillVendorStatusCheckboxSelectedValue)
  {dispatch(setSkillVendorSearchCheckboxValue(knownTalent, doNotUse, skillVendorStatus, liveActionVoiceGenderMale, liveActionVoiceGenderFemale, voiceActorTheatricalExperience,
  voiceActorTVExperience, voiceActorVideoGamesExperience,voiceActorPromoOrCommercialsExperience,voiceActorAnimationMaleVoiceGender,voiceActorAnimationFemaleVoiceGender,
voiceActorLiveActionExperience,voiceActorAnimationExperience,voiceActorDubbingExperience,voiceActorAudiobooksExperience, voiceActorVoiceOverExperience,
voiceActorRadioExperience,voiceActorTheatreActorExperience,voiceActorMovieActorExperience,voiceActorAudioDescriptionExperience, bookerTheatricalExperience,
bookerTVExperience, bookerInteractiveExperience, singerMaleVoiceGender, singerFemaleVoiceGender, singerDubbingExperience,singerStageExperience,singerTheatreExperience,
singerTalentShowExperience, directorTheatricalExperience, directorTVExperience, directorGamesExperience, directorPromoOrCommercialsExperience,
directorLiveActionExperience, directorAnimationExperience, directorDubbingDirectorExperience, directorVoiceOverDirectorExperience, directorSongDirectorExperience,
directorDubbingActorExperience, directorStageDirectorExperience, directorMovieDirectorExperience, directorAudioDescriptionExperience, lyricistMusicalExperience,
lyricistTheatreExperience, lyricistPromoCommercialsExperience, lyricistExperience, lyricistDubbingExperience, lyricistMusicianExperience,
translatorTheatricalExperience, translatorTVExperience, translatorGamesExperience, translatorPromoOrCommercialsExperience, translatorLiveActionExperience,
translatorAnimationExperience, translatorSubtitlesExperience, translatorDubbingExperience, translatorVoiceOverExperience, translatorGamingExperience,
translatorAudioDescriptionExperience,translatorHOHSDHCCExperience, editorDubbingExperience, editorVoiceOverExperience, editorSongsExperience, editorProToolsExperience,
editorDolby51Experience, editorAtmosExperience, editorFoleyExperience, editorRecordingEditingExperience, editorDialogueEditingExperience, editorMusicAndEffectsExperience,
editorMixEditingExperience, editorPreparingTakesExperience, editorAudioDescriptionExperience, adaptorTheatricalExperience,adaptorTVExperience, adaptorGamesExperience,
adaptorPromoOrCommercialsExperience, adaptorLiveActionExperience, adaptorAnimationExperience, adaptorAdaptorExperience, adaptorDubbingDirectorExperience,
adaptorTranslatorExperience, adaptorVoiceActorExperience, adaptorAudioDescriptionExperience,soundEngineerDubbingExperience, soundEngineerVoiceOverExperience,
soundEngineerSongsExperience, soundEngineerProToolsExperience,soundEngineerDolby51Experience,soundEngineerAtmosExperience,soundEngineerFoleyExperience,
soundEngineerDialogueRecordingExperience,soundEngineerSongRecordingExperience,soundEngineerDialogueMixingExperience,soundEngineerSongMixingExperience,
soundEngineerAudioDescriptionMixingExperience,singerGenderNeutralVoice,voiceActorGenderNeutralVoice,adaptorDoNotUse, bookerDoNotUse, directorDoNotUse, editorDoNotUse, lyricistDoNotUse, singerDoNotUse,
soundEngineerDoNotUse, translatorDoNotUse, voiceActorDoNotUse, skillVendorStatusCheckboxSelectedValue ))},
  clearSkillVendorSearchFields() { dispatch(clearSkillVendorSearchFields()) }
})
//export default connect(mapStateToProps, mapDispatchToProps)(WithAjax(SkillVendorSearch))

export default compose(connect(mapStateToProps, mapDispatchToProps),WithNotify,WithAjax)(SkillVendorSearch)
